<template>
  <div>
    <div
      style="position: fixed; top: 20px; z-index: 6; backdrop-filter: blur(2px)"
      v-if="LoaderStatus"
    >
      <Spinner />
    </div>
    <div class="main-container bluebtn overflow-hidden">
      <div
        class="
          asc-page-heading
          d-flex
          align-items-center
          justify-content-between
        "
      >
        <div>User Management</div>
        <div>
          <b-button
            @click="
              (addUserForm = true), (userStatus = 'Add'), clearUserFormData()
            "
            v-show="
              tabName == 'users' &&
              (rolesdata.includes('PUSH_USER') ||
                rolesdata.includes('SUB_ADMIN'))
            "
            class="acs-addBtn widthhundredpx-125 btn-position"
            :disabled="checkboxval"
          >
            <img
              src="../../assets/img/accessconnew/whitePlus.svg"
              alt
              class="mr-2"
            />
            <span class>User</span>
          </b-button>
        </div>
        <div>
          <b-button
            @click="
              resetRoleData(),
                (rolecontainer = true),
                (roleStatus = 'Add'),
                clearRolesFormData(),
                clearEditRoles()
            "
            v-show="tabName == 'roles' && rolesdata.includes('PUSH_ROLE')"
            class="acs-addBtn widthhundredpx-125 btn-position"
          >
            <img
              src="../../assets/img/accessconnew/whitePlus.svg"
              alt
              class="mr-2"
            />
            <span class>Roles</span>
          </b-button>
        </div>
      </div>
      <div
        :class="!checkboxval ? 'accessControl-main-class' : 'folder-container'"
      >
        <div class="relativeclass">
          <div class="access-cntrl-tabs">
            <b-tabs content-class="mt-1 position-relative" v-model="tabIndex">
              <b-tab
                title="Users"
                @click="tabName = 'users'"
                v-if="
                  rolesdata.includes('VIEW_ADMIN') ||
                  rolesdata.includes('SUB_ADMIN')
                "
              >
                <div
                  v-if="
                    rolesdata.includes('VIEW_ADMIN') ||
                    rolesdata.includes('SUB_ADMIN')
                  "
                  class="acs-sel-tab"
                ></div>
                <template v-if="!checkboxval">
                  <!-- new table design starts from here -->
                  <div class="userAccess-main-table" id="scrollToUser">
                    <div class="userAccess-table-head">
                      <div
                        :class="
                          rolesdata.includes('VIEW_ADMIN') &&
                          !rolesdata.includes('SUB_ADMIN')
                            ? 'userAccess-first-col'
                            : 'userAccess-second-col'
                        "
                      >
                        User name
                        <img
                          v-if="sortBy != 'username'"
                          @click="sortData('username', 1, 'user')"
                          class="pointer ml-2"
                          src="../../assets/img/accessconnew/nosort.svg"
                          alt
                        />
                        <img
                          v-else-if="sortBy && order == 1"
                          @click="sortData('username', -1, 'user')"
                          class="pointer ml-2"
                          src="../../assets/img/accessconnew/ascSort.svg"
                          alt
                        />
                        <img
                          v-else-if="sortBy && order == -1"
                          @click="sortData('username', 1, 'user')"
                          class="pointer ml-2"
                          src="../../assets/img/accessconnew/descSort.svg"
                          alt
                        />
                      </div>
                      <div class="userAccess-second-col">
                        Email
                        <img
                          v-if="sortBy != 'email'"
                          @click="sortData('email', 1, 'user')"
                          class="pointer ml-2"
                          src="../../assets/img/accessconnew/nosort.svg"
                          alt
                        />
                        <img
                          v-else-if="sortBy && order == 1"
                          @click="sortData('email', -1, 'user')"
                          class="pointer ml-2"
                          src="../../assets/img/accessconnew/ascSort.svg"
                          alt
                        />
                        <img
                          v-else-if="sortBy && order == -1"
                          @click="sortData('email', 1, 'user')"
                          class="pointer ml-2"
                          src="../../assets/img/accessconnew/descSort.svg"
                          alt
                        />
                      </div>
                      <div
                        v-if="
                          rolesdata.includes('VIEW_ADMIN') &&
                          !rolesdata.includes('SUB_ADMIN')
                        "
                        class="userAccess-third-col"
                      >
                        Sub-Admin
                      </div>
                      <div
                        v-if="
                          rolesdata.includes('VIEW_ADMIN') &&
                          !rolesdata.includes('SUB_ADMIN')
                        "
                        class="userAccess-fourth-col"
                      >
                        Added by
                        <img
                          v-if="sortBy != 'createdByUserName'"
                          @click="sortData('createdByUserName', 1, 'user')"
                          class="pointer ml-2"
                          src="../../assets/img/accessconnew/nosort.svg"
                          alt
                        />
                        <img
                          v-else-if="sortBy && order == 1"
                          @click="sortData('createdByUserName', -1, 'user')"
                          class="pointer ml-2"
                          src="../../assets/img/accessconnew/ascSort.svg"
                          alt
                        />
                        <img
                          v-else-if="sortBy && order == -1"
                          @click="sortData('createdByUserName', 1, 'user')"
                          class="pointer ml-2"
                          src="../../assets/img/accessconnew/descSort.svg"
                          alt
                        />
                      </div>
                      <div
                        v-if="rolesdata.includes('SUB_ADMIN')"
                        class="userAccess-second-col"
                      >
                        Role Type
                        <img
                          v-if="sortBy != 'roleName'"
                          @click="sortData('roleName', 1, 'user')"
                          class="pointer ml-2"
                          src="../../assets/img/accessconnew/nosort.svg"
                          alt
                        />
                        <img
                          v-else-if="sortBy && order == 1"
                          @click="sortData('roleName', -1, 'user')"
                          class="pointer ml-2"
                          src="../../assets/img/accessconnew/ascSort.svg"
                          alt
                        />
                        <img
                          v-else-if="sortBy && order == -1"
                          @click="sortData('roleName', 1, 'user')"
                          class="pointer ml-2"
                          src="../../assets/img/accessconnew/descSort.svg"
                          alt
                        />
                      </div>
                      <div class="userAccess-fifth-col">Landing Page</div>
                      <div class="userAccess-sixth-col text-center">
                        Actions
                      </div>
                    </div>
                    <div class="userAccess-table-body">
                      <template v-if="filterUserPanel.length == 0">
                        <div
                          class="
                            d-flex
                            flex-column
                            align-items-center
                            justify-content-center
                          "
                          style="height: calc(100vh - 345px)"
                        >
                          <div
                            v-if="!LoaderStatus && filterUserPanel.length == 0"
                            class="
                              d-flex
                              flex-column
                              align-items-center
                              justify-content-center
                            "
                          >
                            <div>
                              <img
                                src="../../assets/img/accessconnew/emptyprivilageBig.svg"
                                alt
                              />
                            </div>
                            <div
                              v-if="
                                searchQuery != 'Loader' && searchQuery != ''
                              "
                              class="
                                mt-2
                                text-center
                                access-font-color
                                w-75
                                text-break
                              "
                            >
                              No matching results for
                              <span class="access-font-color-b text-center"
                                >"{{ searchQuery }}"</span
                              >
                            </div>
                            <div
                              v-else
                              class="mt-2 text-center access-font-color"
                            >
                              No data found
                            </div>
                          </div>
                        </div>
                      </template>
                      <template v-else>
                        <div
                          v-for="(row, index) in filterUserPanel"
                          :key="index"
                          class="userAccess-table-row"
                          :style="
                            (!row.subAdmin || row.subAdminRoles.length === 0) &&
                            'font-size: unset !important;'
                          "
                        >
                          <template v-if="row.view == false">
                            <div class="gridgreencolorDynamic-user"></div>
                            <div
                              :class="
                                rolesdata.includes('VIEW_ADMIN') &&
                                !rolesdata.includes('SUB_ADMIN')
                                  ? 'userAccess-first-col'
                                  : 'userAccess-second-col'
                              "
                            >
                              <div class="text-truncate w-100">
                                <span
                                  class="text-truncate d-inline-block"
                                  style="min-width: auto; max-width: 90%"
                                  v-if="userStatus == 'Add'"
                                  v-b-tooltip.hover.bottom="row.username"
                                  >{{ row.username | accesscontroluser }}</span
                                >
                                <span v-else>{{
                                  row.username | accesscontroluser
                                }}</span>
                              </div>
                              <div
                                v-if="
                                  rolesdata.includes('VIEW_ADMIN') &&
                                  !rolesdata.includes('SUB_ADMIN')
                                "
                                class="user-sub-font text-truncate"
                              >
                                <div
                                  class="d-inline-block text-truncate"
                                  style="min-width: auto; max-width: 80%"
                                  v-b-tooltip.hover.bottom="
                                    row.roles.join(' + ')
                                  "
                                >
                                  {{ row.roles.join(" + ") }}
                                </div>
                              </div>
                            </div>
                            <div class="userAccess-second-col">
                              <span
                                v-if="userStatus == 'Add'"
                                v-b-tooltip.hover.bottom="row.email"
                                >{{ row.email | accesscontroluser }}</span
                              >
                              <span v-else>{{
                                row.email | accesscontroluser
                              }}</span>
                            </div>
                            <div
                              v-if="
                                rolesdata.includes('VIEW_ADMIN') &&
                                !rolesdata.includes('SUB_ADMIN')
                              "
                              class="userAccess-third-col text-truncate"
                            >
                              <div
                                class="text-truncate mt-1"
                                style="
                                  min-width: auto;
                                  max-width: 90%;
                                  display: inline-block;
                                "
                                v-b-tooltip.hover.bottom="
                                  row.subAdminRoles.join(', ')
                                "
                                v-if="
                                  row.subAdmin && row.subAdminRoles.length !== 0
                                "
                              >
                                {{ row.subAdminRoles.join(", ") }}
                              </div>
                              <div v-else class="d-flex">
                                <img
                                  src="../../assets/img/accessconnew/blueline.svg"
                                  alt
                                />
                              </div>
                            </div>
                            <div
                              v-if="
                                rolesdata.includes('VIEW_ADMIN') &&
                                !rolesdata.includes('SUB_ADMIN')
                              "
                              class="userAccess-fourth-col"
                            >
                              {{
                                row.createdByUserName &&
                                formattedUsername(row.createdByUserName)
                              }}
                            </div>
                            <div
                              v-if="rolesdata.includes('SUB_ADMIN')"
                              class="userAccess-second-col text-truncate"
                            >
                              <div
                                v-if="userStatus == 'Add'"
                                class="d-inline-block text-truncate"
                                style="min-width: auto; max-width: 80%"
                                v-b-tooltip.hover.bottom="row.roles.join(' + ')"
                              >
                                {{ row.roles.join(" + ") }}
                              </div>
                              <div v-else>{{ row.roles.join(" + ") }}</div>
                            </div>
                            <div class="userAccess-fifth-col">
                              <span
                                v-if="userStatus == 'Add'"
                                v-b-tooltip.hover.bottom="
                                  showDashboardText(row.landingPage)
                                "
                              >
                                {{
                                  showDashboardText(row.landingPage)
                                    | accesscontLandingPage
                                }}
                              </span>
                              <span v-else>
                                {{
                                  showDashboardText(row.landingPage)
                                    | accesscontLandingPage
                                }}
                              </span>
                            </div>
                            <div
                              class="
                                userAccess-sixth-col
                                d-flex
                                align-items-center
                                justify-content-center
                              "
                            >
                              <img
                                @click="
                                  userStatus == 'Edit' ? '' : viewUser(row)
                                "
                                class="mr-3"
                                v-b-tooltip.hover.top="
                                  userStatus == 'Edit' ? '' : 'View'
                                "
                                src="../../assets/img/accessconnew/blueEye.svg"
                                alt="/"
                              />
                              <img
                                v-if="
                                  (rolesdata.includes('PUT_USER') ||
                                    rolesdata.includes('SUB_ADMIN')) &&
                                  !row.permissions.includes(
                                    'GET_VENDOR_DASHBOARD'
                                  )
                                "
                                @click="
                                  userStatus == 'Edit'
                                    ? ''
                                    : copyEditUserData(row)
                                "
                                :class="userStatus == 'Edit' ? '' : 'pointer'"
                                class="mr-3"
                                v-b-tooltip.hover.top="
                                  userStatus == 'Edit' ? '' : 'Edit'
                                "
                                src="../../assets/img/accessconnew/blueEdit.svg"
                                alt
                              />
                              <img
                                class="mr-3"
                                style="cursor: not-allowed"
                                v-else-if="
                                  (rolesdata.includes('PUT_USER') ||
                                    rolesdata.includes('SUB_ADMIN')) &&
                                  row.permissions.includes(
                                    'GET_VENDOR_DASHBOARD'
                                  )
                                "
                                src="../../assets/img/accessconnew/Edit.svg"
                                alt
                              />
                              <img
                                v-if="
                                  (rolesdata.includes('DELETE_USER') ||
                                    rolesdata.includes('SUB_ADMIN')) &&
                                  !row.permissions.includes(
                                    'GET_VENDOR_DASHBOARD'
                                  )
                                "
                                @click="
                                  userStatus == 'Edit'
                                    ? ''
                                    : openUserDeleteModal(row)
                                "
                                :class="userStatus == 'Edit' ? '' : 'pointer'"
                                v-b-tooltip.hover.top="
                                  userStatus == 'Edit' ? '' : 'Delete'
                                "
                                src="../../assets/img/accessconnew/blueBin.svg"
                                alt
                              />
                              <img
                                style="cursor: not-allowed"
                                v-else-if="
                                  (rolesdata.includes('DELETE_USER') ||
                                    rolesdata.includes('SUB_ADMIN')) &&
                                  row.permissions.includes(
                                    'GET_VENDOR_DASHBOARD'
                                  )
                                "
                                src="../../assets/img/accessconnew/Delete.svg"
                                alt
                              />
                            </div>
                          </template>
                        </div>
                      </template>
                    </div>
                    <div
                      class="
                        acs-paginaTion-new
                        d-flex
                        justify-content-between
                        align-items-center
                      "
                    >
                      <div class="d-flex">
                        <span class="acs-gotopage-text p-1 mr-2"
                          >Go to page</span
                        >
                        <b-form-input
                          v-model="goToPage"
                          autocomplete="off"
                          @keyup.enter="goToPages()"
                          @keypress="NumbersOnly"
                          type="text"
                          class="acs-pagination-num"
                          @paste="handlePaste"
                        ></b-form-input>
                        <div class="acs-pagination-addbtn">
                          <span
                            :class="
                              goToPage === null ||
                              goToPage == '' ||
                              !iscontainsNumber
                                ? 'disableDeleteIcon pl-3 mt-1'
                                : 'pointer pl-3 mt-1'
                            "
                          >
                            <img
                              @click="
                                goToPage === null ||
                                goToPage == '' ||
                                !iscontainsNumber
                                  ? ''
                                  : goToPages()
                              "
                              src="../../assets/panelist/page_arrow.svg"
                              alt
                            />
                          </span>
                        </div>
                      </div>

                      <div class="pagination">
                        <b-pagination
                          v-model="currentPage"
                          @input="
                            (LoaderStatus = true),
                              getAccessData(),
                              (goToPage = null)
                          "
                          :total-rows="total"
                          :per-page="count"
                          align="center"
                          first-number
                          last-number
                        >
                          <template #prev-text>
                            <span>
                              <img
                                src="../../assets/img/accessconnew/pageleft.svg"
                                alt
                              />
                            </span>
                          </template>
                          <template #next-text>
                            <span>
                              <img
                                src="../../assets/img/accessconnew/pageright.svg"
                                alt
                              />
                            </span>
                          </template>
                        </b-pagination>
                      </div>
                      <div class="d-flex align-items-center">
                        <PageInput
                          :pagecount="count"
                          @update-value="updatePage"
                        />

                        <div
                          class="
                            acs-gotopage-text
                            mr-2
                            ml-4
                            d-flex
                            justify-content-end
                          "
                        >
                          Showing :
                          <div
                            class="text-truncate ml-2 results-individual-width"
                            v-if="pageStart > total"
                          >
                            0
                          </div>
                          <div
                            v-else
                            class="text-truncate ml-2 results-individual-width"
                          >
                            {{ pageStart }}
                          </div>
                          <div class="text-truncate results-individual-width">
                            -
                          </div>
                          <div class="text-truncate results-individual-width">
                            {{ pageEnd }}
                          </div>
                          <div
                            class="text-truncate ml-1 results-individual-width"
                          >
                            of
                          </div>
                          <div
                            class="text-truncate ml-1 results-individual-width"
                            style="max-width: 20%"
                          >
                            {{ total }}
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </template>
              </b-tab>
              <b-tab
                title="Roles"
                class="roles"
                @click="tabName = 'roles'"
                v-if="rolesdata.includes('GET_ROLE')"
              >
                <div
                  v-if="
                    !rolesdata.includes('VIEW_ADMIN') &&
                    !rolesdata.includes('SUB_ADMIN') &&
                    rolesdata.includes('GET_ROLE')
                  "
                  class="acs-sel-tab left-20"
                ></div>
                <div
                  v-else-if="rolesdata.includes('GET_ROLE')"
                  class="acs-sel-tab left-150"
                ></div>
                <!-- new roles table design starts from here -->
                <div class="userAccess-main-table">
                  <div class="userAccess-table-head">
                    <div class="roleAccess-first-col">
                      Role
                      <img
                        v-if="sortBy != 'roleName'"
                        @click="sortData('roleName', 1, 'role')"
                        class="pointer ml-2"
                        src="../../assets/img/accessconnew/nosort.svg"
                        alt
                      />
                      <img
                        v-else-if="sortBy && order == 1"
                        @click="sortData('roleName', -1, 'role')"
                        class="pointer ml-2"
                        src="../../assets/img/accessconnew/ascSort.svg"
                        alt
                      />
                      <img
                        v-else-if="sortBy && order == -1"
                        @click="sortData('roleName', 1, 'role')"
                        class="pointer ml-2"
                        src="../../assets/img/accessconnew/descSort.svg"
                        alt
                      />
                    </div>
                    <div class="roleAccess-second-col">
                      Role Description
                      <img
                        v-if="sortBy != 'description'"
                        @click="sortData('description', 1, 'role')"
                        class="pointer ml-2"
                        src="../../assets/img/accessconnew/nosort.svg"
                        alt
                      />
                      <img
                        v-else-if="sortBy && order == 1"
                        @click="sortData('description', -1, 'role')"
                        class="pointer ml-2"
                        src="../../assets/img/accessconnew/ascSort.svg"
                        alt
                      />
                      <img
                        v-else-if="sortBy && order == -1"
                        @click="sortData('description', 1, 'role')"
                        class="pointer ml-2"
                        src="../../assets/img/accessconnew/descSort.svg"
                        alt
                      />
                    </div>
                    <div class="roleAccess-third-col">No. of Users</div>
                    <div class="roleAccess-fourth-col text-center">Actions</div>
                  </div>
                  <div class="userAccess-table-body-2" id="scrollToRole">
                    <template v-if="roleData.length == 0 && !LoaderStatus">
                      <div
                        class="
                          d-flex
                          flex-column
                          align-items-center
                          justify-content-center
                        "
                        style="height: calc(100vh - 312px)"
                      >
                        <div
                          class="
                            d-flex
                            flex-column
                            align-items-center
                            justify-content-center
                          "
                        >
                          <div>
                            <img
                              src="../../assets/img/accessconnew/emptyprivilageBig.svg"
                              alt
                            />
                          </div>
                          <div
                            v-if="searchQuery != 'Loader' && searchQuery != ''"
                            class="
                              mt-2
                              text-center
                              access-font-color
                              w-75
                              text-break
                            "
                          >
                            No matching results for
                            <span class="access-font-color-b"
                              >"{{ searchQuery }}"</span
                            >
                          </div>
                          <div
                            v-else
                            class="mt-2 text-center access-font-color"
                          >
                            No data found
                          </div>
                        </div>
                      </div>
                    </template>
                    <template v-else>
                      <div
                        v-for="(data, index) in roleData"
                        :key="index"
                        class="userAccess-table-row"
                      >
                        <template v-if="data.view == false">
                          <div class="gridgreencolorDynamic-role"></div>
                          <div class="roleAccess-first-col">
                            <span
                              v-if="roleStatus == 'Add'"
                              v-b-tooltip.hover.bottom="data.roleName"
                              >{{ data.roleName | accesscontrolroles }}</span
                            >
                            <span v-else>
                              {{ data.roleName | accesscontrolroles }}
                            </span>
                          </div>
                          <div class="roleAccess-second-col">
                            <span
                              v-if="roleStatus == 'Add'"
                              v-b-tooltip.hover.bottom="data.description"
                            >
                              {{ data.description | accesscontrolrolesdesc }}
                            </span>
                            <span v-else>
                              {{ data.description | accesscontrolrolesdesc }}
                            </span>
                            <img
                              v-if="!data.description"
                              src="../../assets/img/accessconnew/blueline.svg"
                              alt
                            />
                          </div>
                          <div class="roleAccess-third-col d-flex">
                            <!-- *************   STYLE BIND IT WHEN INTEGRATING  ************ -->
                            <!-- style="width: 100px;"     WHEN 4 CIRCLES -->
                            <!-- style="width: 70px;"      WHEN 3 CIRCLES -->
                            <!-- style="width: 45px;"      WHEN 2 CIRCLES -->
                            <!-- style="width: 20px;"      WHEN 1 CIRCLE -->
                            <div
                              v-if="data.users"
                              class="
                                d-flex
                                align-items-center
                                position-relative
                              "
                              :style="
                                data.users.length > 3
                                  ? 'width: 100px'
                                  : data.users.length == 3
                                  ? 'width: 70px;'
                                  : data.users.length == 2
                                  ? 'width: 45px;'
                                  : data.users.length == 1
                                  ? 'width: 20px;'
                                  : ''
                              "
                            >
                              <img
                                v-if="data.users.length == 0"
                                src="../../assets/img/accessconnew/blueline.svg"
                                alt
                              />
                              <div
                                v-if="data.users.length > 0"
                                class="roundDarkBlue"
                                style="left: 0px"
                                v-b-tooltip.hover.top="
                                  data.users[0].userPermissions.username
                                "
                              >
                                {{ data.users[0].userPermissions.userIcon }}
                              </div>
                              <div
                                v-if="data.users.length > 1"
                                class="roundDarkBlue"
                                style="left: 25px"
                                v-b-tooltip.hover.top="
                                  data.users[1].userPermissions.username
                                "
                              >
                                {{ data.users[1].userPermissions.userIcon }}
                              </div>
                              <div
                                v-if="data.users.length > 2"
                                class="roundDarkBlue"
                                style="left: 50px"
                                v-b-tooltip.hover.top="
                                  data.users[2].userPermissions.username
                                "
                              >
                                {{ data.users[2].userPermissions.userIcon }}
                              </div>
                              <div
                                v-if="data.users.length == 4"
                                class="roundDarkBlue"
                                style="left: 75px"
                                v-b-tooltip.hover.top="
                                  data.users[3].userPermissions.username
                                "
                              >
                                {{ data.users[3].userPermissions.userIcon }}
                              </div>
                              <div
                                v-if="data.users.length > 4"
                                class="roundLightBlue"
                                style="left: 75px"
                                v-b-tooltip.hover.top="
                                  getRemainingNamesTooltip(data.users)
                                "
                              >
                                +{{ data.users.length - 3 }}
                              </div>
                            </div>
                          </div>
                          <div
                            class="
                              roleAccess-fourth-col
                              d-flex
                              justify-content-center
                            "
                          >
                            <img
                              @click="
                                clearEditRoles(),
                                  roleStatus == 'Edit' ? '' : viewrole(data)
                              "
                              class="mr-3"
                              v-b-tooltip.hover.top="
                                roleStatus == 'Edit' ? '' : 'View'
                              "
                              src="../../assets/img/accessconnew/blueEye.svg"
                              alt
                            />
                            <img
                              v-if="
                                rolesdata.includes('PUT_ROLE') &&
                                !data.roles.includes('EXTERNAL_ACCESS')
                              "
                              @click="
                                clearEditRoles(),
                                  roleStatus == 'Edit'
                                    ? ''
                                    : copyEditRoles(data)
                              "
                              :class="roleStatus == 'Edit' ? '' : 'pointer'"
                              class="mr-3"
                              v-b-tooltip.hover.top="
                                roleStatus == 'Edit' ? '' : 'Edit'
                              "
                              src="../../assets/img/accessconnew/blueEdit.svg"
                              alt
                            />
                            <img
                              v-if="
                                rolesdata.includes('PUT_ROLE') &&
                                data.roles.includes('EXTERNAL_ACCESS')
                              "
                              class="mr-3 disabled-access-img"
                              src="../../assets/img/accessconnew/blueEdit.svg"
                              alt
                            />
                            <img
                              v-if="
                                rolesdata.includes('DELETE_ROLE') &&
                                !checkRoleEdit(data.roleName)
                              "
                              @click="
                                roleStatus == 'Edit'
                                  ? ''
                                  : openRoleDeleteModal(data)
                              "
                              :class="roleStatus == 'Edit' ? '' : 'pointer'"
                              v-b-tooltip.hover.top="
                                roleStatus == 'Edit' ? '' : 'Delete'
                              "
                              src="../../assets/img/accessconnew/blueBin.svg"
                              alt
                            />
                            <img
                              style="cursor: not-allowed"
                              v-if="
                                rolesdata.includes('DELETE_ROLE') &&
                                checkRoleEdit(data.roleName)
                              "
                              src="../../assets/img/accessconnew/Delete.svg"
                              alt
                            />
                          </div>
                        </template>
                      </div>
                    </template>
                  </div>
                </div>
              </b-tab>
            </b-tabs>
          </div>
          <template v-if="checkboxval">
            <TeamsGridView :canEdit="false" />
          </template>

          <!-- NEW DESIGN -->
          <div
            v-if="
              tabName == 'users' &&
              rolesdata.includes('VIEW_ADMIN') &&
              !rolesdata.includes('SUB_ADMIN')
            "
            class="
              switch-position
              d-flex
              align-items-center
              justify-content-between
              folder-title
            "
          >
            <b-form-checkbox v-model="checkboxval" name="check-button" switch
              >Operational Structure</b-form-checkbox
            >
          </div>

          <b-button
            ref="userdrop"
            v-if="tabName !== 'roles'"
            @click="
              (selectedRole = filter),
                showMainFilter && (showFilterOptions = false),
                (showMainFilter = !showMainFilter)
            "
            class="acs-addBtn btn-position"
            :disabled="checkboxval"
          >
            <img
              class="mr-2 mb-1"
              src="../../assets/img/accessconnew/whiteFilter.svg"
              alt
            />
            <div
              class="mb-3"
              style="position: absolute; top: -2px; left: 41px"
              v-if="filter"
            >
              <img src="../../assets/panelist/fil_selected.svg" alt />
            </div>
            Filter
          </b-button>

          <div
            v-if="showMainFilter"
            ref="userfilterdropdown"
            v-closable="{
              exclude: ['userdrop', 'userfilterdropdown'],
              handler: 'hideUserFilterDropdown',
            }"
            class="acs-filter p-3"
          >
            <div class="topDiv">
              <SelectCustom
                :placeholder="'Select Role'"
                :id="'aceess-role'"
                :values="rolesForFilter"
                :dropdown="true"
                @select-value="selectedRole = $event"
                :vmodel="selectedRole"
                :label="'Role :'"
              />
            </div>
            <!-- <div class="acs-black-txt">Role :</div>
            <div
              ref="filterRole"
              @click="showFilterOptions = !showFilterOptions"
              class="acs-filter-dropdown mt-2 position-relative pointer"
            >
              <span v-if="!selectedRole" class="acs-filter-dropdown-place"
                >Select Role</span
              >
              <span v-else class="text-truncate">{{ selectedRole }}</span>

              <img
                src="../../assets/img/accessconnew/blueDownArrowSmall.svg"
                alt
              />
            </div>
            <div
              v-if="showFilterOptions"
              class="acs-dropdown"
              ref="acsdropdown"
              v-closable="{
                exclude: ['filterRole', 'acsdropdown'],
                handler: 'hideUserFilterRoleDropdown',
              }"
            >
              <b-form-group>
                <b-form-checkbox
                  class="qb-dropdown-option-sing pointer text-break py-0"
                  size="sm"
                  :class="
                    selectedRole == option.roleName &&
                    'qb-dropdown-option-selected'
                  "
                  v-for="option in filterrecruiters"
                  :key="option.roleName"
                  :value="option"
                  v-model="selectedRole"
                  @change="
                    (selectedRole = option.roleName),
                      (showFilterOptions = false)
                  "
                  >{{ option.roleName }}</b-form-checkbox
                >
              </b-form-group>
            </div> -->
            <div class="d-flex justify-content-between mt-4">
              <b-button
                class="acs-cancelBtn-filter"
                @click="
                  (showMainFilter = false), !filter && (selectedRole = '')
                "
                >Cancel</b-button
              >
              <div class="d-flex">
                <b-button
                  class="acs-cancelBtn-filter mr-3"
                  :disabled="!selectedRole"
                  @click="
                    (selectedRole = ''),
                      filter &&
                        ((filter = ''),
                        (LoaderStatus = true),
                        (showMainFilter = false),
                        getAccessData())
                  "
                  >Reset</b-button
                >
                <b-button
                  class="acs-cancelBtn-filter"
                  :disabled="!selectedRole"
                  @click="
                    (filter = selectedRole),
                      (showMainFilter = false),
                      (LoaderStatus = true),
                      getAccessData()
                  "
                  >Apply</b-button
                >
              </div>
            </div>
          </div>
        </div>
      </div>

      <!-- add users container starts -->
      <transition name="slide">
        <div v-if="addUserForm" class="accesscontrol-role-main-container">
          <div class="p-3">
            <div class="d-flex align-items-center justify-content-between">
              <div class="position-absolute pointer accesscontrol-backArrow">
                <img
                  v-if="userStatus == 'Add'"
                  @click="(addUserForm = false), clearUserFormData()"
                  src="../../assets/img/accessconnew/boxBackArrow.svg"
                  alt
                />

                <img
                  v-if="userStatus == 'Edit'"
                  @click="
                    (addUserForm = false),
                      (userStatus = 'Add'),
                      clearUserFormData()
                  "
                  src="../../assets/img/accessconnew/boxBackArrow.svg"
                  alt
                />
              </div>
              <div class="addrole-heading ml-3 pt-1">
                <span>{{
                  userStatus === "Add" ? "Add User" : "Edit User"
                }}</span>
              </div>
              <div class="rotate-on-hover pointer">
                <img
                  v-if="userStatus == 'Add'"
                  v-b-tooltip.hover.top="'Close'"
                  @click="(addUserForm = false), clearUserFormData()"
                  src="../../assets/img/accessconnew/blueCross.svg"
                  alt
                />

                <img
                  v-if="userStatus == 'Edit'"
                  v-b-tooltip.hover.top="'Close'"
                  @click="
                    (addUserForm = false),
                      (userStatus = 'Add'),
                      clearUserFormData()
                  "
                  src="../../assets/img/accessconnew/blueCross.svg"
                  alt
                />
              </div>
            </div>
            <hr class="mb-0" />
            <div class="add-user-overflow">
              <b-row class="pl-2 pr-2">
                <b-col>
                  <div
                    class="topDiv mt-2"
                    :class="{ 'mb-2': $v.user.name.$error }"
                  >
                    <InputField
                      :type="'text'"
                      :label="'User Name'"
                      :mandatory="true"
                      :placeholder="'Enter your Username'"
                      :id="'acess-username'"
                      :value="$v.user.name.$model"
                      :vmodel="$v.user.name.$model"
                      :showError="$v.user.name.$error"
                      @select-value="$v.user.name.$model = $event"
                    />
                    <div
                      v-if="$v.user.name.$dirty && !$v.user.name.required"
                      class="errortxt position-absolute"
                    >
                      Required
                    </div>
                    <div
                      v-if="!$v.user.name.maxLength && $v.user.name.required"
                      class="errortxt position-absolute"
                    >
                      Should not exceed 128 characters
                    </div>
                    <div
                      v-if="!$v.user.name.alphaSpecial && $v.user.name.required"
                      class="errortxt position-absolute"
                    >
                      Please Enter a Valid name
                    </div>
                  </div>
                </b-col>
              </b-row>
              <b-row class="pl-2 pr-2">
                <b-col>
                  <div
                    class="topDiv mt-2"
                    :class="{ 'mb-2': $v.user.emailid.$error }"
                  >
                    <InputField
                      :type="'email'"
                      :label="'Email'"
                      :mandatory="true"
                      :placeholder="'Enter your Email ID'"
                      :disabled="userStatus == 'Edit'"
                      :id="'acess-email'"
                      :value="$v.user.emailid.$model"
                      :vmodel="$v.user.emailid.$model"
                      :showError="$v.user.emailid.$error"
                      @select-value="$v.user.emailid.$model = $event"
                    />
                    <div
                      v-if="$v.user.emailid.$dirty && !$v.user.emailid.required"
                      class="errortxt position-absolute"
                    >
                      Required
                    </div>
                    <div
                      v-else-if="!$v.user.emailid.maxLength"
                      class="errortxt position-absolute"
                    >
                      Should not exceed 64 characters
                    </div>
                    <div
                      v-else-if="!$v.user.emailid.email"
                      class="errortxt position-absolute"
                    >
                      Email is invalid
                    </div>
                  </div>
                </b-col>
              </b-row>
              <b-row class="pl-2 pr-2">
                <b-col>
                  <div class="position-relative">
                    <div
                      ref="rec"
                      class="topDiv mt-2 pointer"
                      @click="roleDropdown()"
                    >
                      <label class="teams-label-font">
                        Select Role(s)
                        <span class="asterik">*</span>
                      </label>
                      <div
                        class="laptopinput d-flex align-items-center"
                        placeholder="Select Role(s)"
                        :class="{ error: $v.roleDropDownValue.$error }"
                      >
                        <div
                          class="selectrole"
                          v-if="roleDropDownValue.length != 0"
                        >
                          {{ getRoleNames(roleDropDownValue) }}
                        </div>
                        <span class="input-placeholder" v-else>Select</span>
                        <img
                          class="access-validationicon-2 pointer"
                          v-if="!selectroleview"
                          src="../../assets/cvsearch/cv-downarrow.svg"
                          alt=""
                        />
                        <img
                          class="access-validationicon-2 pointer"
                          v-else
                          src="../../assets/cvsearch/cv-uparrow.svg"
                          alt=""
                        />
                      </div>
                      <div
                        v-if="
                          $v.roleDropDownValue.$dirty &&
                          !$v.roleDropDownValue.required
                        "
                        class="errortxt position-absolute"
                      >
                        Required
                      </div>
                    </div>
                    <div
                      v-if="selectroleview"
                      class="acess-cj-filter-modal"
                      ref="recdropdown"
                      v-closable="{
                        exclude: ['rec', 'recdropdown'],
                        handler: 'hideroleDropdown',
                      }"
                    >
                      <div class="relativeclass">
                        <div class="recsearchicon-pos">
                          <img
                            src="../../assets/img/accessconnew/inputsearch.svg"
                            alt
                          />
                        </div>
                        <b-form-input
                          class="acs-inputField"
                          type="search"
                          placeholder="Search"
                          v-model="searchrec"
                        ></b-form-input>
                        <b-form-group class="acs-dd-group">
                          <b-form-checkbox
                            class="qb-dropdown-option-sing pointer"
                            size="sm"
                            :class="
                              checkRoleSelected(
                                option.roleName,
                                roleDropDownValue
                              ) && 'qb-dropdown-option-selected'
                            "
                            v-for="option in filterUserRoles"
                            :key="option.roleName"
                            :value="option"
                            v-model="$v.roleDropDownValue.$model"
                            @change="selectMultipleRoles()"
                            >{{ option.roleName }}</b-form-checkbox
                          >
                        </b-form-group>
                        <div
                          v-if="filterUserRoles.length == 0"
                          class="mt-2 hist-date-font text-center p-3"
                        >
                          No Roles found
                        </div>
                      </div>
                    </div>
                  </div>
                </b-col>
              </b-row>
              <div v-if="showPanelDetails || showPanelData">
                <b-row class="pl-5 pr-2">
                  <b-col>
                    <div
                      class="topDiv mt-2"
                      :class="{ 'mb-2': $v.user.roles.panelPhone.$error }"
                    >
                      <InputField
                        :type="'number'"
                        :label="'Panelist Contact No.'"
                        :mandatory="true"
                        :placeholder="'Enter Panelist Contact No.'"
                        :id="'phoneNumber'"
                        :value="$v.user.roles.panelPhone.$model"
                        :vmodel="$v.user.roles.panelPhone.$model"
                        :showError="$v.user.roles.panelPhone.$error"
                        @select-value="$v.user.roles.panelPhone.$model = $event"
                      />
                      <div
                        v-if="
                          $v.user.roles.panelPhone.$dirty &&
                          !$v.user.roles.panelPhone.required
                        "
                        class="errortxt position-absolute"
                      >
                        Required
                      </div>
                      <div
                        v-else-if="$v.user.roles.panelPhone.$error"
                        class="errortxt position-absolute"
                      >
                        Phone number is invalid
                      </div>
                    </div>
                  </b-col>
                </b-row>
                <b-row class="pl-5 pr-2">
                  <b-col>
                    <div class="topDiv mt-2 panellist-tags users-tag">
                      <label class="acs-input-head">
                        Panelist Area of Expertise
                        <span class="asterik">*</span>
                      </label>
                      <!-- <b-form-tags
                            class="ac-inputField text-truncate"
                            id="input-1"
                            placeholder="Enter Area of Expertise"
                            remove-on-delete
                          >
                      </b-form-tags>-->
                      <div
                        ref="expertise"
                        tabindex="0"
                        @focusout="closeDropdownOnFocusOutAoe"
                        class="position-relative"
                      >
                        <div @click="expertiseFunction()">
                          <b-form-tags
                            type="text"
                            :class="{ error: $v.user.roles.panelaoe.$error }"
                            id="input-1"
                            placeholder="Enter Area of Expertise"
                            class="laptopinput text-truncate w-100"
                            v-model.trim="$v.user.roles.panelaoe.$model"
                            no-outer-focus
                            :tag-validator="tagValidatoraoe"
                            invalid-tag-text="Duplicate tag(s)"
                            remove-on-delete
                            :separator="','"
                            style="
                              min-height: auto !important;
                              max-height: 55px !important;
                              overflow-y: auto;
                              padding-top: 7px;
                            "
                          >
                            <template
                              v-slot="{
                                tags,
                                inputAttrs,
                                inputHandlers,
                                tagVariant,
                                removeTag,
                              }"
                            >
                              <b-input-group
                                class="cust-group-input"
                                id="addcontainer-tag"
                              >
                                <div class="d-flex flex-wrap w-100">
                                  <div
                                    class="
                                      cust-btn-select
                                      d-flex
                                      flex-wrap
                                      align-items-center
                                    "
                                    style="width: fit-content"
                                  >
                                    <b-form-tag
                                      v-for="tag in tags"
                                      @remove="removeTag(tag)"
                                      :key="tag"
                                      :title="tag"
                                      :variant="tagVariant"
                                      class="mr-1 mb-1"
                                      >{{ tag }}</b-form-tag
                                    >
                                  </div>
                                  <b-form-input
                                    id="input-tag"
                                    v-bind="inputAttrs"
                                    v-on="inputHandlers"
                                    placeholder="Enter Area of Expertise"
                                    class="tags-inputField p-0 mb-1"
                                  ></b-form-input>
                                </div>
                              </b-input-group>
                            </template>
                          </b-form-tags>
                        </div>
                        <div
                          v-if="aoe == true"
                          class="qb-filter-modal-sug w-100"
                          ref="expdropdown"
                        >
                          <div class="relativeclass aoeinput opt-check">
                            <div class="acscontrol-skill-searchpos">
                              <img
                                src="../../assets/img/accesscontrol/inputsearch.svg"
                                alt
                              />
                            </div>
                            <b-form-input
                              class="w-100 inputField options"
                              type="text"
                              placeholder="Search"
                              v-model.trim="searchexp"
                              debounce="500"
                              @update="searchExp"
                            ></b-form-input>
                            <b-overlay :show="spinnerStatus" rounded="sm">
                              <b-form-group
                                class="
                                  qb-dd-group-sug
                                  min-height-adjustment-sugg
                                "
                                v-if="searchexpres.length > 0"
                              >
                                <b-form-checkbox
                                  class="pointer options"
                                  size="sm"
                                  v-for="option in searchexpres"
                                  :key="option.expertise"
                                  :value="option.expertise"
                                  v-model="user.roles.panelaoe"
                                  name="flavour-4a"
                                  :class="{
                                    selectedTag: isSelectedaoe(
                                      option.expertise
                                    ),
                                    'qb-dropdown-option-sugg': !isSelectedaoe(
                                      option.expertise
                                    ),
                                  }"
                                  >{{ option.expertise }}</b-form-checkbox
                                >
                              </b-form-group>
                              <div
                                v-else-if="
                                  searchexpres.length == 0 &&
                                  searchexp.length > 0 &&
                                  searchexp !== ''
                                "
                                class="mt-2 add-panel-name text-center p-3"
                                size="sm"
                              >
                                No matching results for&nbsp;
                                <span class="font-weight-bold"
                                  >"{{ searchexp }}"</span
                                >.
                              </div>
                            </b-overlay>
                          </div>
                        </div>
                      </div>
                      <div
                        v-if="
                          $v.user.roles.panelaoe.$dirty &&
                          !$v.user.roles.panelaoe.required
                        "
                        class="errortxt position-absolute mt-3"
                      >
                        Required
                      </div>
                      <div class="formtags-subtext">
                        Press "Enter" to add area of expertise
                      </div>
                    </div>
                  </b-col>
                </b-row>
                <b-row class="pl-5 pr-2">
                  <b-col>
                    <div
                      class="topDiv mt-2 panellist-tags users-tag"
                      :class="{ 'mb-2': $v.user.roles.panelSkills.$error }"
                    >
                      <label class="acs-input-head">
                        Panelist Skills
                        <span class="asterik">*</span>
                      </label>
                      <div
                        ref="skills"
                        tabindex="1"
                        @focusout="closeDropdownOnFocusOut"
                        class="position-relative"
                      >
                        <div @click="skillFunction()">
                          <b-form-tags
                            type="text"
                            @input="skillFunction()"
                            id="input-2"
                            :class="{ error: $v.user.roles.panelSkills.$error }"
                            placeholder="Enter Skills"
                            class="text-truncate w-100 laptopinput"
                            v-model.trim="$v.user.roles.panelSkills.$model"
                            no-outer-focus
                            remove-on-delete
                            :separator="','"
                            style="
                              min-height: auto !important;
                              max-height: 55px !important;
                              overflow-y: auto;
                              padding-top: 7px;
                            "
                          >
                            <template
                              v-slot="{
                                tags,
                                inputAttrs,
                                inputHandlers,
                                tagVariant,
                                removeTag,
                              }"
                            >
                              <b-input-group
                                class="cust-group-input"
                                id="addcontainer-tag1"
                              >
                                <div class="d-flex flex-wrap w-100">
                                  <div
                                    class="
                                      cust-btn-select
                                      d-flex
                                      flex-wrap
                                      align-items-center
                                    "
                                    style="width: fit-content"
                                  >
                                    <b-form-tag
                                      v-for="tag in tags"
                                      @remove="removeTag(tag)"
                                      :key="tag"
                                      :title="tag"
                                      :variant="tagVariant"
                                      class="mr-1 mb-1"
                                      >{{ tag }}</b-form-tag
                                    >
                                  </div>
                                  <b-form-input
                                    id="input-tag1"
                                    v-bind="inputAttrs"
                                    v-on="inputHandlers"
                                    placeholder="Enter Skills"
                                    class="tags-inputField mb-1 p-0"
                                  ></b-form-input>
                                </div>
                              </b-input-group>
                            </template>
                          </b-form-tags>
                        </div>
                        <div
                          v-if="skilltag == true"
                          class="qb-filter-modal-sug w-100"
                          ref="skilldropdown"
                        >
                          <div class="position-relative aoeinput opt-check">
                            <div class="acscontrol-skill-searchpos">
                              <img
                                src="../../assets/img/accesscontrol/inputsearch.svg"
                                alt
                              />
                            </div>
                            <b-form-input
                              class="w-100 inputField options"
                              type="text"
                              placeholder="Search"
                              v-model.trim="searchskl"
                              debounce="500"
                              @update="searchSkl"
                            ></b-form-input>

                            <b-overlay :show="spinnerStatus" rounded="sm">
                              <b-form-group
                                class="
                                  qb-dd-group-sug
                                  min-height-adjustment-sugg
                                "
                                v-if="searchsklres.length > 0"
                              >
                                <b-form-checkbox
                                  class="pointer options"
                                  size="sm"
                                  v-for="option in searchsklres"
                                  :key="option.skill"
                                  name="flavour-4a"
                                  :value="option.skill"
                                  v-model="user.roles.panelSkills"
                                  :class="{
                                    selectedTag: isSelectedskl(option.skill),
                                    ' qb-dropdown-option-sugg': !isSelectedskl(
                                      option.skill
                                    ),
                                  }"
                                  >{{ option.skill }}</b-form-checkbox
                                >
                              </b-form-group>
                              <div
                                v-else-if="
                                  searchsklres.length == 0 &&
                                  searchskl.length > 0 &&
                                  searchskl !== ''
                                "
                                class="mt-2 add-panel-name text-center p-3"
                                size="sm"
                              >
                                No matching results for&nbsp;
                                <span class="font-weight-bold"
                                  >"{{ searchskl }}"</span
                                >.
                              </div>
                            </b-overlay>
                          </div>
                        </div>
                      </div>

                      <!-- <b-form-tags
                            class="ac-inputField text-truncate"
                            id="input-1"
                            placeholder="Enter Skills"
                            remove-on-delete
                          >
                      </b-form-tags>-->
                      <div
                        v-if="
                          $v.user.roles.panelSkills.$dirty &&
                          !$v.user.roles.panelSkills.required
                        "
                        class="errortxt position-absolute mt-3"
                      >
                        Required
                      </div>
                      <div class="formtags-subtext">
                        Press "Enter" to add skills
                      </div>
                    </div>
                  </b-col>
                </b-row>
              </div>

              <!-- <b-row>
              <b-col>
                <div class="topDiv access-dashboard mt-2">
                  <label class="acs-input-head"
                    >Dashboard<span class="asterik">*</span></label
                  >
                  <b-form-select
                    value-field="value"
                    text-field="text"
                    :options="dashboardOptions"
                    v-model="$v.user.roles.landingPage.$model"
                    :disabled="roleDropDownValue.length == 0"
                    :class="
                      $v.user.roles.landingPage.$error
                        ? 'error'
                        : roleDropDownValue.length == 0
                        ? 'access-disableinput'
                        : 'laptopinput pointer'
                    "
                  >
                  </b-form-select>
                  <img
                    class="access-validationicon-2"
                    src="../../assets/img/accessconnew/blueDownArrow.svg"
                    alt=""
                  />
                  <div
                    class="access-validationicon-dash"
                    v-if="
                      $v.user.roles.landingPage.$dirty &&
                      !$v.user.roles.landingPage.required
                    "
                    v-b-tooltip.hover.top.v-danger="{
                      content: 'Required',
                    }"
                  >
                    <img src="../../assets/deletepopupicon.svg" alt="" />
                  </div>
                </div>
              </b-col>
              </b-row>-->

              <!-- NEW DESIGN -->
              <b-row class="pl-2 pr-2">
                <b-col>
                  <div
                    class="topDiv mt-2"
                    :class="{ 'mt-3': $v.roleDropDownValue.$error }"
                  >
                    <label class="acs-input-head">
                      Landing Page
                      <span class="asterik">*</span>
                    </label>

                    <!-- CLASS - disable-inputField    FOR DISABLE -->
                    <!-- CLASS - addUser-error   FOR ERROR -->
                    <SelectDropdown
                      :id="'access'"
                      :dropdownOptions="dashboardOptions"
                      :showError="showLandingError"
                      :disableDropdown="roleDropDownValue.length == 0"
                      :text="user.roles.dashboard"
                      :value="user.roles.landingPage"
                      :placeholder="'Select Landing Page'"
                      @setValue="setLandingPage"
                    />
                    <div
                      v-if="showLandingError"
                      class="errortxt position-absolute"
                    >
                      Required
                    </div>
                  </div>
                </b-col>
              </b-row>
              <b-row
                v-if="
                  rolesdata.includes('VIEW_ADMIN') &&
                  !rolesdata.includes('SUB_ADMIN')
                "
                class="pl-2 mt-3 mb-1 pr-2"
              >
                <b-col cols="1" class="mt-2" style="max-width: 4.2%">
                  <div class="common-single-checkbox">
                    <b-form-checkbox
                      v-model="user.subAdmin"
                      class="radio-class"
                    ></b-form-checkbox>
                  </div>
                </b-col>
                <b-col>
                  <div class="acs-input-head mb-1">Role type as Non-Admin</div>
                  <div class="addUser-font">
                    Created user will have permissions to add other users
                  </div>
                </b-col>
              </b-row>
              <b-row
                v-if="
                  rolesdata.includes('VIEW_ADMIN') &&
                  !rolesdata.includes('SUB_ADMIN') &&
                  user.subAdmin
                "
                class="pl-2 pr-2"
              >
                <b-col>
                  <div class="position-relative">
                    <div
                      ref="subrec"
                      class="topDiv mt-2 pointer"
                      @click="(searchrec = ''), (showSubRoles = !showSubRoles)"
                    >
                      <label class="acs-input-head">
                        Sub-Admin
                        <span class="asterik">*</span>
                      </label>
                      <div
                        class="laptopinput p-2 d-flex align-items-center"
                        placeholder="Select"
                        :class="{ error: $v.subAdminRoleDropDownValue.$error }"
                      >
                        <div
                          class="selectrole"
                          v-if="subAdminRoleDropDownValue.length != 0"
                        >
                          {{ getRoleNames(subAdminRoleDropDownValue) }}
                        </div>
                        <span class="input-placeholder" v-else>Select</span>

                        <img
                          class="access-validationicon-2"
                          src="../../assets/img/accessconnew/blueDownArrow.svg"
                          alt
                        />
                      </div>
                      <div
                        v-if="
                          $v.subAdminRoleDropDownValue.$dirty &&
                          !$v.subAdminRoleDropDownValue.required
                        "
                        class="errortxt position-absolute"
                      >
                        Required
                      </div>
                    </div>
                    <div
                      v-if="showSubRoles"
                      class="acess-cj-filter-modal"
                      ref="subrecdropdown"
                      v-closable="{
                        exclude: ['subrec', 'subrecdropdown'],
                        handler: 'hideSubRoleDropdown',
                      }"
                    >
                      <div class="relativeclass">
                        <div class="recsearchicon-pos">
                          <img
                            src="../../assets/img/accessconnew/inputsearch.svg"
                            alt
                          />
                        </div>
                        <b-form-input
                          class="acs-inputField"
                          type="search"
                          placeholder="Search"
                          v-model="searchrec"
                        ></b-form-input>
                        <b-form-group class="acs-dd-group">
                          <b-form-checkbox
                            class="qb-dropdown-option-sing pointer"
                            size="sm"
                            :class="
                              checkRoleSelected(
                                option.roleName,
                                subAdminRoleDropDownValue
                              ) && 'qb-dropdown-option-selected'
                            "
                            v-for="option in filterUserRoles"
                            :key="option.roleName"
                            :value="option"
                            v-model="$v.subAdminRoleDropDownValue.$model"
                            >{{ option.roleName }}</b-form-checkbox
                          >
                        </b-form-group>
                        <div
                          v-if="filterUserRoles.length == 0"
                          class="mt-2 hist-date-font text-center p-3"
                        >
                          No Roles found
                        </div>
                      </div>
                    </div>
                  </div>
                </b-col>
              </b-row>
              <hr class="mt-3 mb-1" />
              <b-row>
                <b-col cols="12">
                  <div class="topDiv newuserdesign">
                    <div class="access-background">
                      <div
                        class="
                          d-flex
                          justify-content-between
                          align-items-center
                        "
                      >
                        <div class="prvilagetxt">Privileges</div>
                        <div class="previlagesubtxt">
                          Privileges for the selected roles:
                          <span class="prvilagetxt-2">
                            {{ newRoleValues.length }}
                          </span>
                        </div>
                      </div>
                      <div
                        class="
                          access-viewuser
                          access-switch
                          access-background-overflow
                        "
                      >
                        <b-row>
                          <b-col
                            cols="3"
                            v-for="option in role_options"
                            :key="option.value"
                          >
                            <b-form-checkbox
                              v-model="newRoleValues"
                              :key="option.value"
                              :value="option.value"
                              name="role-check-button"
                              switch
                              disabled
                              >{{ option.text }}</b-form-checkbox
                            >
                          </b-col>
                        </b-row>
                      </div>
                    </div>
                  </div>
                </b-col>
              </b-row>
            </div>

            <b-row class="d-flex justify-content-end border-top mt-2">
              <b-button
                class="acs-addBtn-slider mt-2 mr-3"
                @click="userStatus === 'Add' ? addUser() : editUser()"
              >
                <span>{{ userStatus === "Add" ? "Add" : "Update" }}</span>
              </b-button>
            </b-row>
          </div>
        </div>
      </transition>
      <!-- add users container end -->

      <!-- view users container starts -->
      <transition name="slide">
        <div v-if="viewusercontainer" class="accesscontrol-role-main-container">
          <div class="p-3">
            <div class="d-flex align-items-center justify-content-between">
              <div
                @click="(viewusercontainer = false), resetStatus()"
                class="position-absolute pointer accesscontrol-backArrow"
              >
                <img src="../../assets/img/accessconnew/boxBackArrow.svg" alt />
              </div>
              <div class="addrole-heading ml-3">View User</div>
              <div class="pointer d-flex align-items-center">
                <img
                  v-if="
                    (rolesdata.includes('PUT_USER') ||
                      rolesdata.includes('SUB_ADMIN')) &&
                    !storeuser.permissions.includes('GET_VENDOR_DASHBOARD')
                  "
                  v-b-tooltip.hover.top="'Edit'"
                  @click="copyEditUserData(storeuser)"
                  src="../../assets/img/accessconnew/blueEditSmall.svg"
                  class="mr-4 pointer"
                  alt
                />
                <img
                  class="mr-4"
                  style="cursor: not-allowed"
                  v-else
                  src="../../assets/img/accessconnew/Edit.svg"
                  alt
                />
                <img
                  class="rotate-on-hover"
                  @click="(viewusercontainer = false), resetStatus()"
                  v-b-tooltip.hover.top="'Close'"
                  src="../../assets/img/accessconnew/blueCross.svg"
                  alt
                />
              </div>
            </div>
            <hr class="mb-0" />
            <b-row class="pl-2 pr-2">
              <b-col>
                <div class="topDiv mt-2">
                  <label class="acs-input-head">
                    User Name
                    <span class="asterik">*</span>
                  </label>
                  <b-form-input
                    class="disable-inputField"
                    id="input-1"
                    disabled
                    v-model="storeuser.username"
                  ></b-form-input>
                </div>
              </b-col>
            </b-row>
            <b-row class="pl-2 pr-2">
              <b-col>
                <div class="topDiv mt-2">
                  <label class="acs-input-head">
                    Email
                    <span class="asterik">*</span>
                  </label>
                  <b-form-input
                    class="disable-inputField"
                    id="input-1"
                    disabled
                    v-model="storeuser.email"
                  ></b-form-input>
                </div>
              </b-col>
            </b-row>
            <b-row class="pl-2 pr-2">
              <b-col>
                <div class="topDiv mt-2">
                  <label class="acs-input-head">
                    Select Role(s)
                    <span class="asterik">*</span>
                  </label>
                  <b-form-input
                    class="disable-inputField"
                    id="input-1"
                    disabled
                    :value="storeuser.roles.join(' + ')"
                  ></b-form-input>
                  <!-- <div
                    class="new-font"
                    v-if="
                      rolesdata.includes('SUB_ADMIN') &&
                      adminRoles(storeuser.roles).length != 0
                    "
                  >
                    *The Role(s) "{{ adminRoles(storeuser.roles).join(" ,") }}"
                    has been added by Admin
                    <b
                      ><span style="color: black !important"
                        >“Mark Phillip”</span
                      ></b
                    >
                  </div> -->
                </div>
              </b-col>
            </b-row>
            <b-row class="pl-2 pr-2">
              <b-col>
                <div class="topDiv mt-2">
                  <label class="acs-input-head">
                    Dashboard
                    <span class="asterik">*</span>
                  </label>
                  <div
                    class="disable-inputField disable-div"
                    id="input-1"
                    disabled
                  >
                    <span style="font-size: 14px; color: #333333">{{
                      showDashboardText(storeuser.landingPage)
                    }}</span>
                  </div>
                </div>
              </b-col>
            </b-row>
            <b-row
              v-if="
                rolesdata.includes('VIEW_ADMIN') &&
                !rolesdata.includes('SUB_ADMIN')
              "
              class="pl-2 mt-3 mb-1 pr-2"
            >
              <b-col cols="1" class="mt-2" style="max-width: 4.2%">
                <div class="common-single-checkbox">
                  <b-form-checkbox
                    v-model="storeuser.subAdmin"
                    disabled
                    class="radio-class"
                  ></b-form-checkbox>
                </div>
              </b-col>
              <b-col>
                <div class="acs-input-head mb-1">Role type as Non-Admin</div>
                <div class="addUser-font">
                  Created user will have permissions to add other users
                </div>
              </b-col>
            </b-row>
            <b-row
              v-if="
                rolesdata.includes('VIEW_ADMIN') &&
                storeuser.subAdmin &&
                !rolesdata.includes('SUB_ADMIN')
              "
              class="pl-2 pr-2"
            >
              <b-col>
                <div class="topDiv mt-2">
                  <label class="acs-input-head">
                    Sub-Admin
                    <span class="asterik">*</span>
                  </label>
                  <b-form-input
                    class="disable-inputField"
                    id="input-1"
                    disabled
                    :value="storeuser.subAdminRoles.join(' + ')"
                  ></b-form-input>
                </div>
              </b-col>
            </b-row>
            <hr class="mt-2 mb-1" />

            <b-row>
              <b-col cols="12">
                <div class="topDiv newuserdesign">
                  <div class="access-role-background">
                    <div
                      class="d-flex justify-content-between align-items-center"
                    >
                      <div class="prvilagetxt">Privileges</div>
                      <div class="previlagesubtxt">
                        Privileges for the selected roles:
                        <span class="prvilagetxt-2">
                          {{ storeuser.permissions.length }}
                        </span>
                      </div>
                    </div>
                    <div
                      class="
                        access-viewuser
                        access-switch
                        access-role-background-overflow
                      "
                      :style="
                        storeuser.subAdmin
                          ? 'height: calc(100vh - 641px)'
                          : 'height: calc(100vh - 570px)'
                      "
                    >
                      <b-row>
                        <b-col
                          cols="3"
                          v-for="option in role_options"
                          :key="option.value"
                        >
                          <b-form-checkbox
                            v-model="storeuser.permissions"
                            :key="option.value"
                            :value="option.value"
                            name="role-check-button"
                            switch
                            disabled
                            >{{ option.text }}</b-form-checkbox
                          >
                        </b-col>
                      </b-row>
                    </div>
                  </div>
                </div>
              </b-col>
            </b-row>
          </div>
        </div>
      </transition>
      <!-- view users container end -->

      <!-- view role container starts -->
      <transition name="slide">
        <div v-if="viewrolecontainer" class="accesscontrol-role-main-container">
          <div class="p-3">
            <div class="d-flex align-items-center justify-content-between">
              <div
                @click="(viewrolecontainer = false), resetroleStatus()"
                class="position-absolute pointer accesscontrol-backArrow"
              >
                <img src="../../assets/img/accessconnew/boxBackArrow.svg" alt />
              </div>
              <div class="addrole-heading ml-3">View Role</div>
              <div
                @click="(viewrolecontainer = false), resetroleStatus()"
                class="rotate-on-hover pointer"
              >
                <img
                  v-b-tooltip.hover.top="'Close'"
                  src="../../assets/img/accessconnew/blueCross.svg"
                  alt
                />
              </div>
            </div>
            <hr class="mb-0" />
            <b-row class="pl-2 pr-2">
              <b-col>
                <div class="topDiv mt-2">
                  <label class="acs-input-head">
                    Role Name
                    <span class="asterik">*</span>
                  </label>
                  <b-form-input
                    class="disable-inputField"
                    id="input-1"
                    disabled
                    v-model="roleName"
                  ></b-form-input>
                </div>
              </b-col>
            </b-row>
            <b-row class="pl-2 pr-2">
              <b-col>
                <div class="topDiv mt-2">
                  <label class="acs-input-head">Role Description &nbsp;</label>
                  <b-form-input
                    class="disable-inputField"
                    id="input-1"
                    disabled
                    placeholder="N/A"
                    v-model="description"
                  ></b-form-input>
                </div>
              </b-col>
            </b-row>

            <hr class="mb-0 mt-2" />

            <b-row>
              <b-col class="roleaccess-background-dis ml-3 mr-3 mb-3 mt-2">
                <div class="access-switch d-flex justify-content-between">
                  <div class="prvilagetxt">Privileges</div>
                  <div class="d-flex align-items-center">
                    <b-form-checkbox
                      v-model="selectAll"
                      switch
                      disabled
                      class="disablepointer"
                      ref="parentCheckbox"
                    ></b-form-checkbox>
                    <img
                      v-if="
                        rolesdata.includes('PUT_ROLE') &&
                        roles_array.includes('EXTERNAL_ACCESS')
                      "
                      src="../../assets/img/accessconnew/blueEditSmall.svg"
                      class="ml-4 disabled-access-img"
                      alt
                    />
                    <img
                      v-b-tooltip.hover.bottom="'Edit'"
                      @mouseenter="showEdittooltip = true"
                      @mouseleave="showEdittooltip = false"
                      v-else-if="rolesdata.includes('PUT_ROLE')"
                      @click="clearEditRoles(), copyEditRoles(storeData)"
                      src="../../assets/img/accessconnew/blueEditSmall.svg"
                      class="ml-4 pointer"
                      alt
                    />
                  </div>
                </div>
                <div class="roleaccess-background-dis-overflow">
                  <div class="ml-3 mr-4">
                    <div
                      v-for="(module, index1) in filteredRoles"
                      :key="index1"
                      class="mt-2 acs-box-border"
                    >
                      <div
                        class="modulecards access-outerbox"
                        :class="[
                          getAccessColorClass(module),
                          module.roleView == true ? 'access-color-full' : '',
                          { 'not-collapsed': !module.collapseOpen },
                        ]"
                        v-b-toggle="'collapse' + index1"
                        @click="module.collapseOpen = !module.collapseOpen"
                      >
                        <div
                          class="
                            module-header
                            d-flex
                            justify-content-between
                            align-items-center
                          "
                        >
                          <div class="access-switch">
                            <b-form-checkbox
                              v-model="module.roleView"
                              :key="module.value"
                              :value="module.value"
                              disabled
                              switch
                            >
                              {{ module.name }}
                              <span class="acs-italic">
                                ({{
                                  module.roleView
                                    ? "Full Access"
                                    : getAccessColorClass(module) ==
                                      "access-color"
                                    ? getRoleCount(module, "selected") +
                                      " out of " +
                                      getRoleCount(module, "all")
                                    : "No Privileges added"
                                }})
                              </span>
                            </b-form-checkbox>
                          </div>
                          <div class="when-open" v-show="module.collapseOpen">
                            <img
                              src="../../assets/img/workbench/uparrow.svg"
                              alt
                            />
                          </div>
                          <div
                            class="when-closed"
                            v-show="!module.collapseOpen"
                          >
                            <img
                              src="../../assets/img/access-drop-down.svg"
                              alt
                            />
                          </div>
                        </div>
                      </div>
                      <b-collapse :id="'collapse' + index1">
                        <div
                          class="
                            access-switch
                            accesscontrol-modulecards
                            pointer
                            when-open
                          "
                        >
                          <template v-if="module.roles.length == 0">
                            <div
                              v-for="(submodule, index2) in module.submodules"
                              :key="index2"
                            >
                              <div
                                class="
                                  d-flex
                                  justify-content-between
                                  align-items-center
                                  access-submodulecards
                                "
                                :class="[
                                  getAccessColorClass(submodule),
                                  submodule.submodView == true
                                    ? 'access-color-full'
                                    : '',
                                  {
                                    'not-collapsed': !submodule.subcollapseOpen,
                                  },
                                  module.submodules.length == 0 ||
                                  !submodule.subcollapseOpen
                                    ? 'mb-3 accesscontrol-opened-br'
                                    : 'accesscontrol-opened-br',
                                ]"
                                v-b-toggle="'collapse-2' + index1 + index2"
                                @click="
                                  submodule.subcollapseOpen =
                                    !submodule.subcollapseOpen
                                "
                              >
                                <div class="access-switch">
                                  <b-form-checkbox
                                    v-model="submodule.submodView"
                                    :key="submodule.value"
                                    :value="submodule.value"
                                    disabled
                                    switch
                                    >{{ submodule.name }}</b-form-checkbox
                                  >
                                </div>
                                <div
                                  class="when-open"
                                  v-show="submodule.subcollapseOpen"
                                >
                                  <img
                                    src="../../assets/img/workbench/uparrow.svg"
                                    alt
                                  />
                                </div>
                                <div
                                  class="when-closed"
                                  v-show="!submodule.subcollapseOpen"
                                >
                                  <img
                                    src="../../assets/img/access-drop-down.svg"
                                    alt
                                  />
                                </div>
                              </div>
                              <b-collapse :id="'collapse-2' + index1 + index2">
                                <div
                                  class="
                                    access-switch access-submodulecards
                                    pointer
                                  "
                                  :class="
                                    submodule.roles.length == 0
                                      ? 'm-3 accesscontrol-closed-br'
                                      : 'mb-3 mt-0 accesscontrol-opened-br'
                                  "
                                >
                                  <b-row>
                                    <b-col
                                      cols="3"
                                      v-for="(
                                        subrole, index
                                      ) in submodule.roles"
                                      :key="index"
                                      class="mt-2"
                                    >
                                      <div class="access-switch">
                                        <b-form-checkbox
                                          v-model="roles_array"
                                          :key="subrole.value"
                                          :value="subrole.value"
                                          disabled
                                          switch
                                          >{{ subrole.text }}</b-form-checkbox
                                        >
                                      </div>
                                    </b-col>
                                  </b-row>
                                </div>
                              </b-collapse>
                            </div>
                          </template>
                          <template v-else>
                            <div class="access-switch pointer">
                              <b-row>
                                <b-col
                                  cols="3"
                                  v-for="(moduleroles, index) in module.roles"
                                  :key="index"
                                  class="mt-2"
                                >
                                  <div class="access-switch">
                                    <b-form-checkbox
                                      v-model="roles_array"
                                      :key="moduleroles.value"
                                      :value="moduleroles.value"
                                      disabled
                                      switch
                                      >{{ moduleroles.text }}</b-form-checkbox
                                    >
                                  </div>
                                </b-col>
                              </b-row>
                            </div>
                          </template>
                        </div>
                      </b-collapse>
                    </div>
                  </div>
                </div>
              </b-col>
            </b-row>
          </div>
        </div>
      </transition>
      <!-- view role container end -->

      <!-- add roles container starts -->
      <transition name="slide">
        <div v-if="rolecontainer" class="accesscontrol-role-main-container">
          <div class="p-3">
            <div class="d-flex align-items-center justify-content-between">
              <div class="position-absolute pointer accesscontrol-backArrow">
                <img
                  v-if="roleStatus == 'Add'"
                  @click="(rolecontainer = false), resetroleStatus()"
                  src="../../assets/img/accessconnew/boxBackArrow.svg"
                  alt
                />

                <img
                  v-if="roleStatus == 'Edit'"
                  @click="
                    (rolecontainer = false),
                      (roleStatus = 'Add'),
                      clearEditRoles()
                  "
                  src="../../assets/img/accessconnew/boxBackArrow.svg"
                  alt
                />
              </div>
              <div class="addrole-heading ml-3 pt-1">
                <span>
                  {{ roleStatus === "Add" ? "Add New Role" : "Edit Role" }}
                </span>
              </div>
              <div class="rotate-on-hover pointer">
                <img
                  v-if="roleStatus == 'Add'"
                  v-b-tooltip.hover.top="'Close'"
                  @click="(rolecontainer = false), resetroleStatus()"
                  src="../../assets/img/accessconnew/blueCross.svg"
                  alt
                />

                <img
                  v-if="roleStatus == 'Edit'"
                  v-b-tooltip.hover.top="'Close'"
                  @click="
                    (rolecontainer = false),
                      (roleStatus = 'Add'),
                      clearEditRoles()
                  "
                  src="../../assets/img/accessconnew/blueCross.svg"
                  alt
                />
              </div>
            </div>
            <hr class="mb-0" />
            <section class="role-first-section">
              <b-row class="pl-2 pr-2">
                <b-col>
                  <div
                    class="topDiv mt-2"
                    :class="{ 'mb-2': $v.rolesData.roleName.$error }"
                  >
                    <InputField
                      :type="'text'"
                      :label="'Role Name'"
                      :mandatory="true"
                      :placeholder="'Enter Role Name'"
                      :id="'acess-rolename'"
                      :value="$v.rolesData.roleName.$model"
                      :vmodel="$v.rolesData.roleName.$model"
                      :showError="$v.rolesData.roleName.$error"
                      :disabled="roleStatus == 'Edit'"
                      @select-value="$v.rolesData.roleName.$model = $event"
                    />
                    <div
                      v-if="
                        $v.rolesData.roleName.$dirty &&
                        !$v.rolesData.roleName.required
                      "
                      class="errortxt position-absolute"
                    >
                      Required
                    </div>
                    <div
                      v-if="
                        !$v.rolesData.roleName.alphaSpecial &&
                        $v.rolesData.roleName.required
                      "
                      class="errortxt position-absolute"
                    >
                      Please Enter a Valid name
                    </div>
                    <div
                      v-if="
                        !$v.rolesData.roleName.maxLength &&
                        $v.rolesData.roleName.required
                      "
                      class="errortxt position-absolute"
                    >
                      Should not exceed 128 characters
                    </div>
                  </div>
                </b-col>
              </b-row>
              <b-row class="mb-2 pl-2 pr-2">
                <b-col>
                  <div
                    class="topDiv mt-2"
                    :class="{ 'mb-2': $v.rolesData.description.$error }"
                  >
                    <InputField
                      :type="'text'"
                      :label="'Role Description'"
                      :placeholder="'Enter Role Description'"
                      :id="'acess-roledesc'"
                      :value="$v.rolesData.description.$model"
                      :vmodel="$v.rolesData.description.$model"
                      :showError="$v.rolesData.description.$error"
                      @select-value="$v.rolesData.description.$model = $event"
                    />
                    <div
                      v-if="!$v.rolesData.description.maxLength"
                      class="errortxt position-absolute"
                    >
                      Should not exceed 250 characters
                    </div>
                  </div>
                </b-col>
              </b-row>
            </section>
            <hr class="mb-0 mt-0" />
            <b-row>
              <b-col class="roleaccess-background ml-3 mr-3 mb-3 mt-2">
                <div class="access-switch d-flex justify-content-between">
                  <div class="prvilagetxt">Privileges</div>
                  <b-form-checkbox
                    v-model="selectAll"
                    switch
                    @change="AllRolSelect"
                    ref="parentCheckbox"
                  ></b-form-checkbox>
                </div>
                <div class="mt-3 d-flex justify-content-between ml-3 mr-4">
                  <div
                    class="position-relative search-bar mb-3"
                    style="width: 80%"
                  >
                    <span>
                      <img
                        class="acs-search-pos"
                        src="../../assets/img/search-bar-icon.svg"
                        alt
                      />
                    </span>
                    <b-form-input
                      class="acs-search-input"
                      type="search"
                      placeholder="Search Privileges"
                      @input="checkSelectAll(), filterSubmoduleViews()"
                      v-model="searchTerm"
                    ></b-form-input>
                  </div>
                  <div
                    class="access-control-filterbox ml-3 pointer"
                    ref="exp"
                    @click="filterview = !filterview"
                  >
                    <div class="d-flex mr-2">
                      <img
                        src="../../assets/img/accessconnew/whiteFilter.svg"
                        alt
                      />
                      <img
                        v-if="selectedFilter.length != 0"
                        style="margin-left: -6px; margin-bottom: 10px"
                        src="../../assets/panelist/fil_selected.svg"
                        alt
                      />
                    </div>

                    <div>Filter</div>
                  </div>
                  <div
                    v-if="filterview"
                    class="cj-filter-modal"
                    ref="filterbox"
                    v-closable="{
                      exclude: ['exp', 'filterbox'],
                      handler: 'hidefiltercard',
                    }"
                  >
                    <div
                      class="pd-checkboxes-background pointer"
                      v-for="(option, index) in filter_option"
                      :class="
                        selectedFilter.includes(option.value) &&
                        'pd-checkboxes-selected'
                      "
                      :key="index"
                    >
                      <b-form-checkbox
                        :value="option.value"
                        size="sm"
                        v-model="selectedFilter"
                        @change="checkSelectAll(), filterSubmoduleViews()"
                      >
                        <div>{{ option.name }}</div>
                      </b-form-checkbox>
                    </div>
                  </div>
                </div>
                <div class="roleaccess-background-overflow">
                  <div
                    v-if="filteredRoles.length == 0"
                    class="
                      h-75
                      d-flex
                      flex-column
                      align-items-center
                      justify-content-center
                    "
                  >
                    <div>
                      <img
                        src="../../assets/img/accessconnew/emptyprivilage.svg"
                        alt
                      />
                    </div>
                    <div class="mt-2 text-center access-font-color">
                      No matching results for "
                      <span class="access-font-color-b">{{ searchTerm }}</span
                      >"
                    </div>
                  </div>
                  <div v-else class="ml-3 mr-4">
                    <div
                      v-for="(module, index1) in filteredRoles"
                      :key="index1"
                      class="mt-2 acs-box-border"
                    >
                      <div
                        class="modulecards access-outerbox"
                        :class="[
                          getAccessColorClass(module),
                          module.roleView == true ? 'access-color-full' : '',
                          { 'not-collapsed': !module.collapseOpen },
                        ]"
                        v-b-toggle="'collapse' + index1"
                        @click="module.collapseOpen = !module.collapseOpen"
                      >
                        <div
                          class="
                            module-header
                            d-flex
                            justify-content-between
                            align-items-center
                          "
                        >
                          <div @click.stop class="access-switch">
                            <b-form-checkbox
                              v-model="module.roleView"
                              :key="module.value"
                              :value="module.value"
                              @change="selectrole(module)"
                              switch
                            >
                              {{ module.name }}
                              <span class="acs-italic">
                                ({{
                                  module.roleView
                                    ? "Full Access"
                                    : getAccessColorClass(module) ==
                                      "access-color"
                                    ? getRoleCount(module, "selected") +
                                      " out of " +
                                      getRoleCount(module, "all")
                                    : "No Privileges added"
                                }})
                              </span>
                            </b-form-checkbox>
                          </div>
                          <div class="when-open" v-show="module.collapseOpen">
                            <img
                              src="../../assets/img/workbench/uparrow.svg"
                              alt
                            />
                          </div>
                          <div
                            class="when-closed"
                            v-show="!module.collapseOpen"
                          >
                            <img
                              src="../../assets/img/access-drop-down.svg"
                              alt
                            />
                          </div>
                        </div>
                      </div>
                      <b-collapse
                        :id="'collapse' + index1"
                        :ref="'collapse' + index1"
                      >
                        <div
                          class="
                            access-switch
                            accesscontrol-modulecards
                            pointer
                            when-open
                          "
                        >
                          <template v-if="module.roles.length == 0">
                            <div
                              v-for="(submodule, index2) in module.submodules"
                              :key="index2"
                            >
                              <div
                                class="
                                  d-flex
                                  justify-content-between
                                  align-items-center
                                  access-submodulecards
                                "
                                :class="[
                                  getAccessColorClass(submodule),
                                  submodule.submodView == true
                                    ? 'access-color-full'
                                    : '',
                                  {
                                    'not-collapsed': !submodule.subcollapseOpen,
                                  },
                                  module.submodules.length == 0 ||
                                  !submodule.subcollapseOpen
                                    ? 'mb-3 accesscontrol-opened-br'
                                    : 'accesscontrol-opened-br',
                                ]"
                                v-b-toggle="`collapse-2${index1 + index2}`"
                                @click="
                                  (submodule.subcollapseOpen =
                                    !submodule.subcollapseOpen),
                                    $forceUpdate()
                                "
                              >
                                <div @click.stop class="access-switch">
                                  <b-form-checkbox
                                    v-model="submodule.submodView"
                                    :key="submodule.value"
                                    :value="submodule.value"
                                    @change="selectSubRole(submodule)"
                                    switch
                                    >{{ submodule.name }}</b-form-checkbox
                                  >
                                </div>
                                <div
                                  class="when-open"
                                  v-show="submodule.subcollapseOpen"
                                >
                                  <img
                                    src="../../assets/img/workbench/uparrow.svg"
                                    alt
                                  />
                                </div>
                                <div
                                  class="when-closed"
                                  v-show="!submodule.subcollapseOpen"
                                >
                                  <img
                                    src="../../assets/img/access-drop-down.svg"
                                    alt
                                  />
                                </div>
                              </div>

                              <b-collapse
                                :id="`collapse-2${index1 + index2}`"
                                :ref="`collapse-2${index1 + index2}`"
                              >
                                <div
                                  class="
                                    access-switch access-submodulecards
                                    pl-32
                                    pointer
                                  "
                                  :class="
                                    submodule.roles.length == 0
                                      ? 'm-3 accesscontrol-closed-br'
                                      : 'mb-3 mt-0 accesscontrol-opened-br'
                                  "
                                >
                                  <b-row>
                                    <b-col
                                      :cols="thirdChildCol(submodule.roles)"
                                      v-for="(
                                        subrole, index
                                      ) in submodule.roles"
                                      :key="index"
                                      class="mt-2"
                                    >
                                      <div class="access-switch">
                                        <b-form-checkbox
                                          v-model="roles_array"
                                          :key="subrole.value"
                                          :value="subrole.value"
                                          @change="selectSubRolVal(subrole)"
                                          switch
                                          >{{ subrole.text }}</b-form-checkbox
                                        >
                                      </div>
                                    </b-col>
                                  </b-row>
                                </div>
                              </b-collapse>
                            </div>
                          </template>
                          <template v-else>
                            <div class="access-switch pointer">
                              <b-row>
                                <b-col
                                  cols="3"
                                  v-for="(moduleroles, index) in module.roles"
                                  :key="index"
                                  class="mt-2"
                                >
                                  <div class="access-switch">
                                    <b-form-checkbox
                                      v-model="roles_array"
                                      :key="moduleroles.value"
                                      :value="moduleroles.value"
                                      @change="
                                        selectRolVal(moduleroles, module.roles)
                                      "
                                      switch
                                      >{{ moduleroles.text }}</b-form-checkbox
                                    >
                                  </div>
                                </b-col>
                              </b-row>
                            </div>
                          </template>
                        </div>
                      </b-collapse>
                    </div>
                  </div>
                </div>
              </b-col>
            </b-row>
            <b-row>
              <b-col>
                <div
                  class="
                    pt-2
                    border-top
                    d-flex
                    align-items-center
                    justify-content-end
                    pr-4
                  "
                >
                  <b-button
                    class="acs-addBtn-slider mr-4"
                    @click="roleStatus === 'Add' ? postRoles() : editRoles()"
                  >
                    <span>{{ roleStatus === "Add" ? "Add" : "Update" }}</span>
                  </b-button>
                </div>
              </b-col>
            </b-row>
          </div>
        </div>
      </transition>
      <!-- add role container end -->

      <!-----------------  Roles Delete Popup starts -------->
      <b-modal
        id="delete-role-modal"
        centered
        hide-footer
        hide-header
        @hidden="$bvModal.hide('delete-role-modal')"
      >
        <div class="d-flex">
          <div class="mr-3">
            <img src="../../assets/img/accessconnew/deletemodal.svg" alt />
          </div>
          <div>
            <div class="d-flex justify-content-between">
              <div class="acs-modal-head">Delete Role</div>
              <div @click="$bvModal.hide('delete-role-modal')">
                <img
                  class="rotate-on-hover"
                  src="../../assets/img/accessconnew/blueCross.svg"
                  alt
                />
              </div>
            </div>
            <div class="acs-modal-content pr-3 mt-1">
              Are you sure you want to delete this role? This action cannot be
              undone.
            </div>
          </div>
        </div>
        <div class="d-flex align-items-center justify-content-end mt-4 bluebtn">
          <b-button
            class="acs-cancelBtn-modal mr-3"
            @click="$bvModal.hide('delete-role-modal')"
            >Cancel</b-button
          >
          <b-button
            class="acs-addBtn-modal"
            @click="deleteRoles(deleteRolesData)"
            >Delete</b-button
          >
        </div>
      </b-modal>
      <!----------------- Roles Delete Popup ends -------->

      <!-----------------  User Delete Popup starts -------->
      <b-modal
        id="delete-user-modal"
        centered
        hide-footer
        hide-header
        @hidden="$bvModal.hide('delete-user-modal')"
      >
        <div class="d-flex">
          <div class="mr-3">
            <img src="../../assets/img/accessconnew/deletemodal.svg" alt />
          </div>
          <div>
            <div class="d-flex justify-content-between">
              <div class="acs-modal-head">Delete User</div>
              <div @click="$bvModal.hide('delete-user-modal')">
                <img
                  class="rotate-on-hover pointer"
                  src="../../assets/img/accessconnew/blueCross.svg"
                  alt
                />
              </div>
            </div>
            <div class="acs-modal-content pr-3 mt-1">
              Deleting this user will revoke all associated permissions and
              remove them from any assigned roles or permissions groups.
            </div>
          </div>
        </div>
        <div class="d-flex align-items-center justify-content-end bluebtn mt-4">
          <b-button
            class="acs-cancelBtn-modal mr-3"
            @click="$bvModal.hide('delete-user-modal')"
            >Cancel</b-button
          >
          <b-button class="acs-addBtn-modal" @click="deleteUser(deleteUserData)"
            >Delete</b-button
          >
        </div>
      </b-modal>

      <!----------------- User Delete Popup ends -------->
    </div>
  </div>
</template>

<script>
// User and roles Api Functions
import {
  postAccessData,
  getUserAccessData,
  deleteAccessData,
  putAccessData,
  userToLicenseData,
  postRoles,
  getRolesDetails,
  putRoles,
  deleteRoles,
  checkPanelExists,
} from "../../utils/apiFunctions.js";

// Create user license
import { mapGetters } from "vuex";
import Spinner from "../../components/fixedcomponents/Spinner.vue";
import {
  required,
  email,
  helpers,
  maxLength,
  requiredIf,
  minLength,
} from "vuelidate/lib/validators";
import toast from "../../components/mixin/toast";
import TeamsGridView from "../Teams/TeamsGridView.vue";
import { NumbersOnly } from "../../controllers/Candidate/helpers";
import SelectDropdown from "../../components/fixedcomponents/Select.vue";
import PageInput from "../../components/InputComponents/PaginationInput.vue";
import { handlePanelData } from "../../controllers/Panelist/asynchronous";
import {
  expertisefunction,
  skillfunction,
} from "../../controllers/Panelist/helpers";
import { searchExp, searchSkl } from "../../controllers/Panelist/asynchronous";
import commonFunc from "../../components/mixin/commonFunctions.js";
import SelectCustom from "../../components/InputComponents/SelectCustom.vue";
import InputField from "../../components/InputComponents/Input.vue";

export default {
  name: "AccessControl",
  components: {
    Spinner,
    TeamsGridView,
    SelectDropdown,
    PageInput,
    SelectCustom,
    InputField,
  },
  data() {
    return {
      aoetags: {
        expertise: [],
      },
      skillstags: {
        skill: [],
      },
      skilltag: false,
      searchexpres: [],
      searchsklres: [],
      spinnerStatus: false,
      searchexp: "",
      searchskl: "",
      aoe: false,
      showPanelData: false,
      panelFailure: false,
      panelId: null,
      panelExists: false,
      showPanelDetails: false,
      showLandingError: false,
      openLandingDropdown: false,
      showEdittooltip: false,
      showFilterOptions: false,
      showMainFilter: false,
      rolecheck: false,
      addUserForm: false,
      rolecontainer: false,
      viewusercontainer: false,
      viewrolecontainer: false,
      checkboxval: false,
      colorselected: false,
      showSubRoles: false,
      tabIndex: 0,
      tabName: "",
      userStatus: "",
      roleStatus: "",
      selectedUserID: "",
      searchrec: "",
      selectedRole: "",
      searchTerm: "",
      sortBy: "",
      filter: "",
      order: null,
      page: 0,
      count: 50,
      total: 0,
      pageStart: null,
      pageEnd: null,
      currentPage: 1,
      goToPage: null,
      storeData: {},
      storeuser: {},
      userRoles: null,
      LoaderStatus: false,
      addRoleForm: false,
      filterview: false,
      selectroleview: false,
      checked: false,
      showModal: false,
      selectAll: false,
      rollallselect: false,
      subrolselect: false,
      allSelected: false,
      indeterminate: false,
      roleView: false,
      submodView: false,
      deleteRolesData: {},
      deleteUserData: {},
      user: {
        name: "",
        emailid: "",
        summary: "",
        subAdmin: false,
        roles: {
          roleName: "",
          description: "",
          roles: [],
          landingPage: "",
          dashboard: "",
          panelPhone: null,
          panelaoe: [],
          panelSkills: [],
        },
      },
      rolesData: {
        roleName: "",
        description: "",
        licenseKey: "",
        project: "recruitment",
        projectPermission: "1",
        roles: [],
      },
      roleData: [],
      roleDropDownValue: [],
      subAdminRoleDropDownValue: [],
      newRoleValues: [],
      rowData: [],
      selectedFilter: [],
      rolesoptions: [],
      roles_array: [],
      user_array: [],
      roles: [],
      dashboardOptions: [],
      userRoleData: [],
      role_options: [
        // GET  : VIEW
        // PUSH : ADD
        // PUT  : EDIT
        // POP  : DELETE

        // ADMIN
        // { text: "Admin", value: "admin" },
        // { text: "View Access Control", value: "VIEW_ADMIN" },
        //JOB DASHBOARD
        { text: "Recruiter View", value: "RECRUITER_VIEW" },
        { text: "Job View", value: "JOB_VIEW" },

        //ACCESS CONTROL -  USER
        { text: "View User", value: "VIEW_ADMIN" },
        { text: "Add User", value: "PUSH_USER" },
        { text: "Edit User", value: "PUT_USER" },
        { text: "Delete User", value: "DELETE_USER" },

        //ACCESS CONTROL -  ROLE
        { text: "View Role", value: "GET_ROLE" },
        { text: "Add Role", value: "PUSH_ROLE" },
        { text: "Edit Role", value: "PUT_ROLE" },
        { text: "Delete Role", value: "DELETE_ROLE" },
        { text: "Hiring Manager", value: "VIEW_MANAGER" },
        { text: "BU Head", value: "VIEW_BUHEAD" },
        { text: "HR", value: "HUMAN_RESOURCES" },
        { text: "View Dashboard", value: "VIEW_DASHBOARD" },

        //CUSTOMER
        { text: "View Customer", value: "GET_CUSTOMER" },
        { text: "Add Customer", value: "PUSH_CUSTOMER" },
        { text: "Edit Customer", value: "PUT_CUSTOMER" },
        { text: "Delete Customer", value: "DELETE_CUSTOMER" },

        //VENDOR
        { text: "View Vendor", value: "GET_VENDOR" },
        { text: "Add Vendor", value: "PUSH_VENDOR" },
        { text: "Edit Vendor", value: "PUT_VENDOR" },
        { text: "Delete Vendor", value: "DELETE_VENDOR" },

        // JOBS
        { text: "View Jobs", value: "GET_JOB" },
        { text: "Create Job", value: "PUSH_JOB" },
        { text: "Clone Job", value: "CLONE_JOB" },
        { text: "Edit Job", value: "PUT_JOB" },
        { text: "Delete Job", value: "DELETE_JOB" },
        {
          text: "Create Feedback Form from Job",
          value: "CREATE_FEEDBACK_FORM_JOB",
        },
        { text: "Create IP from Job", value: "CREATE_IP_JOB" },
        // { text: "Assign Job's", value: "ASSIGN_JOB" },

        // CANDIDATE
        // { text: "View Candidate", value: "GET_CANDIDATE" },
        { text: "Add Candidate", value: "PUSH_CANDIDATE" },
        { text: "Edit Candidate", value: "PUT_CANDIDATE" },
        { text: "Delete Candidate", value: "DELETE_CANDIDATE" },
        { text: "Add Candidate To Jobs", value: "PUSH_CANDIDATE_JD" },
        { text: "Send Job Opportunity", value: "SEND_JOB_OPPURTUNITY" },

        // PANEL
        { text: "View Panel", value: "GET_PANEL" },
        { text: "Add Panel", value: "PUSH_PANEL" },
        { text: "Edit Panel", value: "PUT_PANEL" },
        { text: "Delete Panel", value: "DELETE_PANEL" },

        // PANEL Dashboard
        { text: "View Panel Dashboard", value: "GET_PANEL_DASHBOARD" },
        { text: "Profile Screening", value: "PROFILE_SCREENING" },
        // WORKBENCH
        { text: "View Workbench Customer", value: "GET_WORKBENCH" },
        // { text: "View Job Dashboard", value: "GET_JOBDASHBOARD" },
        // { text: "Add Candidate", value: "PUSH_JOB_CANDIDATE" },
        // { text: "View_Workbench", value: "GET_WORKBENCH" },
        // { text: "Add_Workbench", value: "PUSH_WORKBENCH" },
        // { text: "Edit_Workbench", value: "PUT_WORKBENCH" },
        // { text: "Delete_Workbench", value: "DELETE_WORKBENCH" },

        // TALENTPOOL
        { text: "View Talentpool", value: "GET_TALENTPOOL" },
        {
          text: "Reassign Talentpool Candidate",
          value: "REASSIGN_TALENTPOOL_CANDIDATE",
        },
        {
          text: "Bookmark Candidate",
          value: "BOOKMARK_TALENTPOOL_CANDIDATE",
        },
        // { text: "Add_Talentpool", value: "PUSH_TALENTPOOL" },
        // { text: "Edit_Talentpool", value: "PUT_TALENTPOOL" },
        // { text: "Delete_Talentpool", value: "DELETE_TALENTPOOL" },

        // REPORTS
        // { text: "View Reports Dashboard", value: "GET_REPORTS" },
        { text: "View Customer Report", value: "GET_REPORT_CUSTOMER" },
        { text: "View Recruiter Report", value: "GET_REPORT_RECRUITER" },
        { text: "View Panelist Reports", value: "GET_REPORT_PANELIST" },
        { text: "View Vendor Reports", value: "GET_REPORT_VENDOR" },
        { text: "View Management Reports", value: "GET_REPORT_MANAGEMENT" },
        // KANBAN
        { text: "View Kanban", value: "GET_JOBDASHBOARD" },
        { text: "View Job Statistics", value: "GET_JOB_STATISTICS" },
        // { text: "View Applications", value: "GET_APPLICATION" },
        { text: "Reassign Candidate", value: "REASSIGN_CANDIDATE" },
        { text: "Trigger CVS", value: "TRIGGER_CVS" },
        { text: "Send for Screening", value: "SEND_SCREENING" },
        { text: "Request Onboarding Documents", value: "REQ_ONBOARDING_DOCS" },
        {
          text: "View Onboarding Documents",
          value: "VIEW_ONBOARDING_DOCS",
        },
        {
          text: "Review Onboarding Documents",
          value: "REVIEW_ONBOARDING_DOCS",
        },
        {
          text: "View Candidate Analysis",
          value: "VIEW_CANDIDATE_ANALYSIS",
        },

        // HR PORTAL
        // { text: "View HR Portal", value: "GET_HRPORTAL" },
        // CV SEARCH
        { text: "View CV Search", value: "GET_CV_SEARCH" },
        { text: "Save Search", value: "SAVE_SEARCH" },
        { text: "Edit Saved Search", value: "PUT_SAVED_SEARCH" },
        { text: "Delete Saved Search", value: "DELETE_SAVED_SEARCH" },
        { text: "View Candidate Profile", value: "GET_PROFILE" },
        { text: "Add Candidate to Job", value: "ADD_TO_JD" },

        // INTERVIEW PORTAl
        { text: "View Interview Process", value: "GET_INTERVIEW" },
        { text: "Add Interview Process", value: "PUSH_INTERVIEW" },
        { text: "Edit Interview Process", value: "PUT_INTERVIEW" },
        { text: "Delete Interview Process", value: "DELETE_INTERVIEW" },
        {
          text: "Create Feedback form from IP",
          value: "PUSH_FEEDBACK_FORM_IP",
        },
        { text: "Clone Interview Process", value: "CLONE_INTERVIEW" },

        // FeedBack Forms
        { text: "View Feedback Form", value: "GET_FEEDBACK_FORM" },
        { text: "Add Feedback Form", value: "PUSH_FEEDBACK_FORM" },
        { text: "Edit Feedback Form", value: "PUT_FEEDBACK_FORM" },
        { text: "Delete Feedback Form", value: "DELETE_FEEDBACK_FORM" },
        { text: "Clone Feedback Form", value: "CLONE_FEEDBACK_FORM" },
        //Job Approval
        { text: "View Job Approval", value: "GET_JD_APPROVAL" },
        { text: "Accept/Reject Job", value: "PUSH_JD_APPROVAL" },
        // Ops Head
        // { text: "View_AcceptJd", value: "GET_ACCEPTJD" },
        // { text: "Add_AcceptJd", value: "PUSH_ACCEPTJD" },
        { text: "View Candidate Approval", value: "GET_ACCEPT_CANDIDATE" },
        { text: "Accept/Reject Candidate", value: "PUSH_ACCEPT_CANDIDATE" },
        // { text: "Edit_AcceptJd", value: "PUT_ACCEPTJD" },
        // { text: "Delete_AcceptJd", value: "DELETE_ACCEPTJD" },

        // Teams Folder
        { text: "View Teams", value: "GET_TEAMS" },
        { text: "Add Teams", value: "PUSH_TEAMS" },
        { text: "Edit Teams", value: "PUT_TEAMS" },
        { text: "Delete Teams", value: "DELETE_TEAMS" },
        { text: "Tag User", value: "TAG_USER" },
        // { text: "Add Sub Group", value: "ADD_SUBGROUP" },
        { text: "Remove User", value: "DELETE_TAGGED_USER" },

        //Documents folder
        { text: "View Document", value: "GET_DOCUMENT" },
        { text: "Add Document", value: "PUSH_DOCUMENT" },
        { text: "Edit Document", value: "PUT_DOCUMENT" },
        { text: "Delete Document", value: "DELETE_DOCUMENT" },
        // Custom Field Folder
        { text: "View Form", value: "GET_FORM" },
        { text: "Edit Form", value: "PUT_FORM" },
        { text: "View Third Party", value: "GET_THIRD_PARTY" },
        { text: "Edit Third Party", value: "PUT_THIRD_PARTY" },
        { text: "View Transactions", value: "GET_TRANSACTIONS" },
        { text: "Hire3x Wallet", value: "HIRE3X_WALLET" },
      ],
      roles_module: [],
      roles_submodule: [],
      allRoleCheck: false,
      // Array of Objects

      allRoles: [
        {
          name: "Job Dashboard",
          roles: [
            { text: "Recruiter View", value: "RECRUITER_VIEW", type: "View" },
            { text: "Job View", value: "JOB_VIEW", type: "View" },
          ],
          roleView: false,
          collapseOpen: false,
        },
        {
          name: "Workbench",
          roles: [],
          submodules: [
            {
              name: "Customers",
              roles: [
                {
                  text: "View Workbench Customer",
                  value: "GET_WORKBENCH",
                  type: "View",
                },
              ],
              submodView: false,
              subcollapseOpen: false,
            },
            {
              name: "Job Description",
              roles: [
                { text: "View Jobs", value: "GET_JOB", type: "View" },
                { text: "Create Job", value: "PUSH_JOB", type: "Add" },
                { text: "Edit Job", value: "PUT_JOB", type: "Edit" },
                { text: "Delete Job", value: "DELETE_JOB", type: "Delete" },
                {
                  text: "Create Feedback Form from Job",
                  value: "CREATE_FEEDBACK_FORM_JOB",
                  type: "Add",
                },
                {
                  text: "Create IP from Job",
                  value: "CREATE_IP_JOB",
                  type: "Add",
                },
                { text: "Clone Job", value: "CLONE_JOB", type: "Add" },
              ],
              submodView: false,
              subcollapseOpen: false,
            },
            // {
            //   name: "Job Details",
            //   roles: [
            //     {
            //       text: "View Job Dashboard",
            //       value: "GET_JOBDASHBOARD",
            //       type: "View",
            //     },
            //     {
            //       text: "Add Candidate",
            //       value: "PUSH_JOB_CANDIDATE",
            //       type: "Add",
            //     },
            //   ],
            //   submodView: false,
            //   subcollapseOpen: false,
            // },
            {
              name: "Kanban",
              roles: [
                {
                  text: "View Kanban",
                  value: "GET_JOBDASHBOARD",
                  type: "View",
                },
                {
                  text: "View Job Statistics",
                  value: "GET_JOB_STATISTICS",
                  type: "View",
                },
                {
                  text: "Reassign Candidate",
                  value: "REASSIGN_CANDIDATE",
                  type: "Edit",
                },
                {
                  text: "Trigger CVS",
                  value: "TRIGGER_CVS",
                  type: "Edit",
                },
                {
                  text: "Send for Screening",
                  value: "SEND_SCREENING",
                  type: "Edit",
                },
                {
                  text: "Request Onboarding Documents",
                  value: "REQ_ONBOARDING_DOCS",
                  type: "Edit",
                },
                {
                  text: "View Onboarding Documents",
                  value: "VIEW_ONBOARDING_DOCS",
                  type: "View",
                },
                {
                  text: "Review Onboarding Documents",
                  value: "REVIEW_ONBOARDING_DOCS",
                  type: "Edit",
                },
                {
                  text: "View Candidate Analysis",
                  value: "VIEW_CANDIDATE_ANALYSIS",
                  type: "View",
                },
              ],
              submodView: false,
              subcollapseOpen: false,
            },
          ],
          roleView: false,
          collapseOpen: false,
        },
        {
          name: "Manage",
          roles: [],
          submodules: [
            {
              name: "Customer",
              roles: [
                { text: "View Customer", value: "GET_CUSTOMER", type: "View" },
                { text: "Add Customer", value: "PUSH_CUSTOMER", type: "Add" },
                { text: "Edit Customer", value: "PUT_CUSTOMER", type: "Edit" },
                {
                  text: "Delete Customer",
                  value: "DELETE_CUSTOMER",
                  type: "Delete",
                },
              ],
              submodView: false,
              subcollapseOpen: false,
            },
            {
              name: "Vendor",
              roles: [
                { text: "View Vendor", value: "GET_VENDOR", type: "View" },
                { text: "Add Vendor", value: "PUSH_VENDOR", type: "Add" },
                { text: "Edit Vendor", value: "PUT_VENDOR", type: "Edit" },
                {
                  text: "Delete Vendor",
                  value: "DELETE_VENDOR",
                  type: "Delete",
                },
              ],
              submodView: false,
              subcollapseOpen: false,
            },
          ],
          roleView: false,
          collapseOpen: false,
        },
        {
          name: "Talent Pool",
          roles: [
            { text: "View Talentpool", value: "GET_TALENTPOOL", type: "View" },
            // { text: "View Candidate", value: "GET_CANDIDATE", type: "View" },
            { text: "Add Candidate", value: "PUSH_CANDIDATE", type: "Add" },
            { text: "Edit Candidate", value: "PUT_CANDIDATE", type: "Edit" },
            {
              text: "Delete Candidate",
              value: "DELETE_CANDIDATE",
              type: "Delete",
            },
            {
              text: "Add Candidate To Jobs",
              value: "PUSH_CANDIDATE_JD",
              type: "Add",
            },
            {
              text: "Send Job Opportunity",
              value: "SEND_JOB_OPPURTUNITY",
              type: "Add",
            },
            {
              text: "Reassign Talentpool Candidate",
              value: "REASSIGN_TALENTPOOL_CANDIDATE",
              type: "Edit",
            },
            {
              text: "Bookmark Candidate",
              value: "BOOKMARK_TALENTPOOL_CANDIDATE",
              type: "Edit",
            },
          ],
          roleView: false,
          collapseOpen: false,
        },
        // {
        //   name: "Access Control",
        //   roles: [{ text: "View Access Control", value: "VIEW_ADMIN", type: "View" }],
        //   roleView: false,
        //   collapseOpen: false,
        // },
        {
          name: "User Management",
          roles: [],
          submodules: [
            {
              name: "Users",
              roles: [
                { text: "View User", value: "VIEW_ADMIN", type: "View" },
                { text: "Add User", value: "PUSH_USER", type: "Add" },
                { text: "Edit User", value: "PUT_USER", type: "Edit" },
                {
                  text: "Delete User",
                  value: "DELETE_USER",
                  type: "Delete",
                },
              ],
              submodView: false,
              subcollapseOpen: false,
            },
            {
              name: "Roles",
              roles: [
                { text: "View Role", value: "GET_ROLE", type: "View" },
                { text: "Add Role", value: "PUSH_ROLE", type: "Add" },
                { text: "Edit Role", value: "PUT_ROLE", type: "Edit" },
                {
                  text: "Delete Role",
                  value: "DELETE_ROLE",
                  type: "Delete",
                },
                {
                  text: "Hiring Manager",
                  value: "VIEW_MANAGER",
                  type: "View",
                },
                {
                  text: "BU Head",
                  value: "VIEW_BUHEAD",
                  type: "View",
                },
                {
                  text: "HR",
                  value: "HUMAN_RESOURCES",
                  type: "View",
                },
              ],
              submodView: false,
              subcollapseOpen: false,
            },
            {
              name: "Panelist",
              roles: [
                { text: "View Panel", value: "GET_PANEL", type: "View" },
                { text: "Add Panel", value: "PUSH_PANEL", type: "Add" },
                { text: "Edit Panel", value: "PUT_PANEL", type: "Edit" },
                { text: "Delete Panel", value: "DELETE_PANEL", type: "Delete" },
              ],
              submodView: false,
              subcollapseOpen: false,
            },
          ],
          roleView: false,
          collapseOpen: false,
        },
        {
          name: "Panelist Dashboard",
          roles: [
            {
              text: "View Panel Dashboard",
              value: "GET_PANEL_DASHBOARD",
              type: "View",
            },
            {
              text: "Profile Screening",
              value: "PROFILE_SCREENING",
              type: "Edit",
            },
          ],
          roleView: false,
          collapseOpen: false,
        },
        {
          name: "Dashboard",
          roles: [
            { text: "View Dashboard", value: "VIEW_DASHBOARD", type: "View" },
          ],
          roleView: false,
          collapseOpen: false,
        },
        {
          name: "Reports",
          roles: [
            // {
            //   text: "View Reports Dashboard",
            //   value: "GET_REPORTS",
            //   type: "View",
            // },
            {
              text: "View Customer Report",
              value: "GET_REPORT_CUSTOMER",
              type: "View",
            },
            {
              text: "View Recruiter Report",
              value: "GET_REPORT_RECRUITER",
              type: "View",
            },
            {
              text: "View Panelist Reports",
              value: "GET_REPORT_PANELIST",
              type: "View",
            },
            {
              text: "View Vendor Reports",
              value: "GET_REPORT_VENDOR",
              type: "View",
            },
            {
              text: "View Management Reports",
              value: "GET_REPORT_MANAGEMENT",
              type: "View",
            },
          ],
          roleView: false,
          collapseOpen: false,
        },
        {
          name: "Hiring Process",
          roles: [],
          submodules: [
            {
              name: "Interview Process",
              roles: [
                {
                  text: "View Interview Process",
                  value: "GET_INTERVIEW",
                  type: "View",
                },
                {
                  text: "Add Interview Process",
                  value: "PUSH_INTERVIEW",
                  type: "Add",
                },
                {
                  text: "Edit Interview Process",
                  value: "PUT_INTERVIEW",
                  type: "Edit",
                },
                {
                  text: "Delete Interview Process",
                  value: "DELETE_INTERVIEW",
                  type: "Delete",
                },
                {
                  text: "Create Feedback form from IP",
                  value: "PUSH_FEEDBACK_FORM_IP",
                  type: "Add",
                },
                {
                  text: "Clone Interview Process",
                  value: "CLONE_INTERVIEW",
                  type: "Add",
                },
              ],
              submodView: false,
              subcollapseOpen: false,
            },
            {
              name: "Feedback Form",
              roles: [
                {
                  text: "View Feedback Form",
                  value: "GET_FEEDBACK_FORM",
                  type: "View",
                },
                {
                  text: "Add Feedback Form",
                  value: "PUSH_FEEDBACK_FORM",
                  type: "Add",
                },
                {
                  text: "Edit Feedback Form",
                  value: "PUT_FEEDBACK_FORM",
                  type: "Edit",
                },
                {
                  text: "Delete Feedback Form",
                  value: "DELETE_FEEDBACK_FORM",
                  type: "Delete",
                },
                {
                  text: "Clone Feedback Form",
                  value: "CLONE_FEEDBACK_FORM",
                  type: "Add",
                },
              ],
              submodView: false,
              subcollapseOpen: false,
            },
          ],
          roleView: false,
          collapseOpen: false,
        },
        // {
        //   name: "HR Portal",
        //   roles: [
        //     { text: "View HR Portal", value: "GET_HRPORTAL", type: "View" },
        //   ],
        //   roleView: false,
        //   collapseOpen: false,
        // },
        {
          name: "Approval",
          roles: [],
          submodules: [
            {
              name: "Job Approval",
              roles: [
                {
                  text: "View Job Approval",
                  value: "GET_JD_APPROVAL",
                  type: "View",
                },
                {
                  text: "Accept/Reject Job",
                  value: "PUSH_JD_APPROVAL",
                  type: "Add",
                },
                // { text: "Edit_jd_approval", value: "PUT_JD_APPROVAL" },
                // { text: "Delete_jd_approval", value: "DELETE_JD_APPROVAL" },
              ],
              submodView: false,
              subcollapseOpen: false,
            },
            {
              name: "Candidate Approval",
              roles: [
                {
                  text: "View Candidate Approval",
                  value: "GET_ACCEPT_CANDIDATE",
                  type: "View",
                },
                {
                  text: "Accept/Reject Candidate",
                  value: "PUSH_ACCEPT_CANDIDATE",
                  type: "Add",
                },
                // { text: "Edit_Candidate", value: "PUT_CANDIDATE" },
                // { text: "Delete_Candidate", value: "DELETE_CANDIDATE" },
              ],
              submodView: false,
              subcollapseOpen: false,
            },
          ],
          roleView: false,
          collapseOpen: false,
        },
        {
          name: "CV Search",
          roles: [
            { text: "View CV Search", value: "GET_CV_SEARCH", type: "View" },
            { text: "Save Search", value: "SAVE_SEARCH", type: "Add" },
            {
              text: "Edit Saved Search",
              value: "PUT_SAVED_SEARCH",
              type: "Edit",
            },
            {
              text: "Delete Saved Search",
              value: "DELETE_SAVED_SEARCH",
              type: "Delete",
            },
            {
              text: "View Candidate Profile",
              value: "GET_PROFILE",
              type: "View",
            },
            { text: "Add Candidate to Job", value: "ADD_TO_JD", type: "Add" },
          ],
          roleView: false,
          collapseOpen: false,
        },
        {
          name: "Teams",
          roles: [
            { text: "View Groups", value: "GET_TEAMS", type: "View" },
            { text: "Add Groups", value: "PUSH_TEAMS", type: "Add" },
            { text: "Edit Groups", value: "PUT_TEAMS", type: "Edit" },
            { text: "Delete Groups", value: "DELETE_TEAMS", type: "Delete" },
            { text: "Tag User", value: "TAG_USER", type: "Add" },
            // { text: "Add Sub Group", value: "ADD_SUBGROUP", type: "Add" },
            {
              text: "Remove User",
              value: "DELETE_TAGGED_USER",
              type: "Delete",
            },
          ],
          roleView: false,
          collapseOpen: false,
        },
        {
          name: "Documents",
          roles: [
            { text: "View Document", value: "GET_DOCUMENT", type: "View" },
            { text: "Add Document", value: "PUSH_DOCUMENT", type: "Add" },
            { text: "Edit Document", value: "PUT_DOCUMENT", type: "Edit" },
            {
              text: "Delete Document",
              value: "DELETE_DOCUMENT",
              type: "Delete",
            },
          ],
          roleView: false,
          collapseOpen: false,
        },
        {
          name: "Configure",
          roles: [],
          submodules: [
            {
              name: "Custom Fields",
              roles: [
                {
                  text: "View Form",
                  value: "GET_FORM",
                  type: "View",
                },
                {
                  text: "Edit Form",
                  value: "PUT_FORM",
                  type: "Edit",
                },
              ],
              submodView: false,
              subcollapseOpen: false,
            },
            {
              name: "Third Party",
              roles: [
                {
                  text: "View Third Party",
                  value: "GET_THIRD_PARTY",
                  type: "View",
                },
                {
                  text: "Edit Third Party",
                  value: "PUT_THIRD_PARTY",
                  type: "Edit",
                },
              ],
              submodView: false,
              subcollapseOpen: false,
            },
          ],

          roleView: false,
          collapseOpen: false,
        },
        {
          name: "Transactions",
          roles: [
            {
              text: "View Transactions",
              value: "GET_TRANSACTIONS",
              type: "View",
            },
            {
              text: "Hire3x Wallet",
              value: "HIRE3X_WALLET",
              type: "View",
            },
          ],
          roleView: false,
          collapseOpen: false,
        },
      ],
      filter_option: [
        { name: "Add Permission", value: "Add" },
        { name: "Edit Permission", value: "Edit" },
        { name: "View Permission", value: "View" },
        { name: "Delete Permission", value: "Delete" },
      ],
    };
  },
  watch: {
    "user.emailid"(val) {
      if (val && this.showPanelDetails) {
        this.checkPanelist();
      }
    },
    roleDropDownValue(val) {
      if (
        val.length != 0 &&
        this.userStatus == "Edit" &&
        this.userRoles.permissions.includes("GET_PANEL_DASHBOARD")
      ) {
        this.checkPanelist();
      }
    },
    dashboardOptions(val) {
      let value = val.filter((obj) => {
        return obj.text == "Panelist Dashboard";
      });
      if (this.userStatus == "Add") {
        if (value.length != 0) {
          this.closePanelistDropdowns();
          this.showPanelDetails = true;
        } else {
          this.showPanelDetails = false;
        }
        if (this.showPanelDetails && this.user.emailid) {
          this.checkPanelist();
        }
      } else if (this.userStatus == "Edit") {
        if (
          value.length != 0 &&
          !this.userRoles.permissions.includes("GET_PANEL_DASHBOARD")
        ) {
          this.closePanelistDropdowns();
          this.showPanelDetails = true;
        } else {
          this.showPanelDetails = false;
        }
      }
      if (
        this.userStatus == "Edit" &&
        this.roleDropDownValue.length != 0 &&
        this.dashboardOptions.length == 0
      ) {
        this.showLandingError = true;
      }
      if (this.roleDropDownValue.length != 0 && this.userStatus == "Edit") {
        this.showLandingError = !this.dashboardOptions.some(
          (obj) => obj.value == this.user.roles.landingPage
        );
      }
    },
    //tabchange with selection in newsidebar
    $route() {
      this.setTabIndex();
    },
    selectedChildCount() {
      const selectedCount = this.selectedChildCount;
      const totalRoles = this.filteredRoles.reduce((total, module) => {
        return (
          total +
          (module.roles.length ||
            module.submodules.reduce(
              (subTotal, submodule) => subTotal + submodule.roles.length,
              0
            ))
        );
      }, 0);
      this.selectAll = selectedCount === totalRoles;
    },
    selectedRoleCount() {
      this.filteredRoles.forEach((module) => {
        if (module.roles.length > 0) {
          const allRolesSelected = module.roles.every((role) =>
            this.roles_array.includes(role.value)
          );
          module.roleView = allRolesSelected;
        } else {
          const allSubmodulesSelected = module.submodules.every((submodule) =>
            submodule.roles.every((role) =>
              this.roles_array.includes(role.value)
            )
          );
          module.roleView = allSubmodulesSelected;
        }
      });
    },
    roles_array: {
      handler() {
        this.updateSubmoduleViews();
      },
      deep: true,
    },
    checkboxval(newValue, oldValue) {
      if (oldValue != newValue) {
        this.$router.push({
          name: "AccessControl",
          query: {
            status: this.$route.query.status,
            structure: this.checkboxval,
          },
        });
      }
    },
    searchQuery(newValue, oldValue) {
      if (newValue != oldValue) {
        if (newValue != "Loader") {
          if (this.tabName == "users") {
            this.LoaderStatus = true;
            this.getAccessData();
          } else {
            this.LoaderStatus = true;
            this.getRolesDetails();
          }
        }
      }
    },
    tabName(newValue) {
      this.setSearchValue();
      // Update the route with the new status query parameter
      if (this.$route.query.status != newValue) {
        this.$router.push({
          name: "AccessControl",
          query: {
            status: newValue,
            structure: this.$route.query.structure,
          },
        });
      }
      this.closeTransition();
    },
  },
  mixins: [toast, commonFunc],
  computed: {
    ...mapGetters({ rolesdata: "roles" }),
    ...mapGetters("userVUEX", {
      licenseKey: "getlicenseKey",
      roleValues: "getRoleValues",
    }),
    ...mapGetters("searchVUEX", {
      searchQuery: "getSearchQuery",
    }),
    userNumber() {
      return this.filterUserPanel.length + 1;
    },
    iscontainsNumber() {
      return /^[1-9]\d*$/.test(this.goToPage);
    },
    filterUserPanel() {
      return this.rowData;
    },
    filterrecruiters() {
      if (this.rolesdata.includes("SUB_ADMIN")) {
        return this.rolesoptions.filter((data) => {
          return (
            this.roleValues.subAdminRoles.includes(data.roleName) &&
            (!this.searchrec ||
              data.roleName
                .toLowerCase()
                .includes(this.searchrec.toLowerCase()))
          );
        });
      } else {
        return this.rolesoptions.filter((data) => {
          return (
            !this.searchrec ||
            data.roleName.toLowerCase().includes(this.searchrec.toLowerCase())
          );
        });
      }
    },
    filterUserRoles() {
      if (
        this.rolesdata.includes("SUB_ADMIN") &&
        this.roleValues.subAdminRoles
      ) {
        return this.userRoleData.filter((obj) => {
          if (this.roleValues.subAdminRoles.includes(obj.roleName)) {
            return (
              !this.searchrec ||
              obj.roleName.toLowerCase().includes(this.searchrec.toLowerCase())
            );
          }
        });
      } else {
        return this.userRoleData.filter((data) => {
          return (
            !this.searchrec ||
            data.roleName.toLowerCase().includes(this.searchrec.toLowerCase())
          );
        });
      }
    },
    filteredRoles() {
      const filteredModules = this.allRoles.filter((module) => {
        // Check if module name matches the search term
        if (module.name.toLowerCase().includes(this.searchTerm.toLowerCase())) {
          return true;
        }

        // Check if any role text matches the search term
        if (this.checkRoleMatch(module)) {
          return true;
        }

        // Check if any submodule name or role text matches the search term
        if (module.submodules && Array.isArray(module.submodules)) {
          if (
            module.submodules.some((submodule) =>
              submodule.name
                .toLowerCase()
                .includes(this.searchTerm.toLowerCase())
            )
          ) {
            return true;
          }
          if (
            module.submodules.some(
              (submodule) =>
                submodule.roles &&
                Array.isArray(submodule.roles) &&
                submodule.roles.some((role) =>
                  role.text
                    .toLowerCase()
                    .includes(this.searchTerm.toLowerCase())
                )
            )
          ) {
            return true;
          }
        }

        return false;
      });

      // Filter roles based on selectedFilter if it is not empty
      if (this.selectedFilter.length > 0) {
        return this.filterRolesonSelectedFilter(filteredModules);
      }
      return filteredModules;
    },

    selectedChildCount() {
      let count = 0;
      this.filteredRoles.forEach((module) => {
        if (module.roles.length > 0) {
          count += module.roles.filter((role) =>
            this.roles_array.includes(role.value)
          ).length;
        } else {
          module.submodules.forEach((submodule) => {
            count += submodule.roles.filter((role) =>
              this.roles_array.includes(role.value)
            ).length;
          });
        }
      });
      return count;
    },
    selectedRoleCount() {
      let count = 0;
      this.filteredRoles.forEach((module) => {
        if (module.roles.length > 0) {
          const roleCount = module.roles.filter((role) =>
            this.roles_array.includes(role.value)
          ).length;
          if (roleCount === module.roles.length) {
            count++;
          }
        } else {
          const submoduleCount = module.submodules.filter((submodule) =>
            submodule.roles.every((role) =>
              this.roles_array.includes(role.value)
            )
          ).length;
          if (submoduleCount === module.submodules.length) {
            count++;
          }
        }
      });
      return count;
    },
    totalPages() {
      return Math.ceil(this.total / this.count);
    },
    checkForReports() {
      return (
        this.newRoleValues.includes("GET_REPORT_CUSTOMER") ||
        this.newRoleValues.includes("GET_REPORT_RECRUITER") ||
        this.newRoleValues.includes("GET_REPORT_PANELIST") ||
        this.newRoleValues.includes("GET_REPORT_VENDOR") ||
        this.newRoleValues.includes("GET_REPORT_MANAGEMENT")
      );
    },
    rolesForFilter() {
      return this.filterrecruiters.map((obj) => {
        obj.key = obj.roleName;
        obj.label = obj.roleName;
        return obj;
      });
    },
  },
  validations: {
    user: {
      name: {
        required,
        maxLength: maxLength(128),
        alphaSpecial: helpers.regex(
          "alphaSpecial",
          /^[a-z0-9·!@#$%^&*()\]\-_=~`{}|:;"'<>,.?\s]+$/i
        ),
      },
      emailid: {
        required,
        email,
        maxLength: maxLength(64),
      },
      roles: {
        panelPhone: {
          required: requiredIf(function () {
            return this.showPanelDetails || this.showPanelData;
          }),
          minLength: minLength(7),
          maxLength: maxLength(10),
          alpha: helpers.regex("alpha", /^\d{7,10}$/),
        },
        panelaoe: {
          required: requiredIf(function () {
            return this.showPanelDetails || this.showPanelData;
          }),
        },
        panelSkills: {
          required: requiredIf(function () {
            return this.showPanelDetails || this.showPanelData;
          }),
        },
        landingPage: {
          required,
        },
      },
    },
    roleDropDownValue: {
      required,
    },
    subAdminRoleDropDownValue: {
      required: requiredIf(function () {
        return (
          this.rolesdata.includes("VIEW_ADMIN") &&
          !this.rolesdata.includes("SUB_ADMIN") &&
          this.user.subAdmin
        );
      }),
    },
    rolesData: {
      roleName: {
        required,
        maxLength: maxLength(128),
        alphaSpecial: helpers.regex(
          "alphaSpecial",
          /^[a-z0-9·!@#$%^&*()\]\-_=~`{}|:;"'<>,.?\s]+$/i
        ),
      },
      description: {
        maxLength: maxLength(250),
      },
    },
  },

  created() {
    this.LoaderStatus = true;
    this.$store.commit("searchVUEX/saveSearchQuery", "");
    this.$store.commit("accessControlVUEX/saveSearchTab", "Users");
    this.$store.commit("teamsVUEX/addFolderContent", {});
    this.$store.commit("teamsVUEX/setActive", "");
    this.$store.commit("teamsVUEX/setLoader", false);
    this.setTabIndex();
    // this.getRolesDetails(true);
    // this.getRolesDetails();
    // this.getAccessData();
    this.searchSkl();
    this.searchExp();
  },
  methods: {
    // adminRoles(roles) {
    //   return roles.filter(
    //     (element) => !this.roleValues.subAdminRoles.includes(element)
    //   );
    // },
    // getSelectedRoles(roles) {
    //   if (this.roleValues.subAdmin) {
    //     return roles.filter((element) => {
    //       this.roleValues.subAdminRoles.includes(element)
    //     });
    //   } else {
    //     return roles;
    //   }
    // },
    hideUserFilterRoleDropdown() {
      this.showFilterOptions = false;
    },
    formattedUsername(username) {
      return username.replace(/\b\w/g, (char) => char.toUpperCase());
    },
    hideSubRoleDropdown() {
      this.showSubRoles = false;
      this.searchrec = "";
    },
    checkRoleSelected(roleName, roles) {
      return roles.some((obj) => obj.roleName === roleName);
    },
    getRemainingNamesTooltip(users) {
      const remainingNames = users
        .slice(3)
        .map((user) => user.userPermissions.username);
      return remainingNames.join(", ");
    },
    closeDropdownOnFocusOutAoe() {
      if (!this.$refs.expertise.contains(event.relatedTarget)) {
        this.aoe = false; // Close the dropdown
      }
    },
    closeDropdownOnFocusOut() {
      if (!this.$refs.skills.contains(event.relatedTarget)) {
        this.skilltag = false; // Close the dropdown
      }
    },
    closePanelistDropdowns() {
      this.aoe = false;
      this.skilltag = false;
    },
    thirdChildCol(roles) {
      if (roles && roles.length === 1) {
        return 12; // Return 12 if roles array has 1 element
      } else if (roles && roles.length === 2) {
        return 6; // Return 6 if roles array has 2 elements
      } else if (roles && roles.length === 3) {
        return 4; // Return 4 if roles array has 3 elements
      } else {
        return 3; // Return 3 otherwise (for lengths other than 1, 2, or 3)
      }
    },
    isSelectedskl(skill) {
      return this.user.roles.panelSkills.includes(skill);
    },
    searchExp() {
      searchExp(this);
    },
    searchSkl() {
      searchSkl(this);
    },
    isSelectedaoe(exp) {
      return this.user.roles.panelaoe.includes(exp);
    },
    expertiseFunction() {
      expertisefunction(this);
    },
    skillFunction() {
      skillfunction(this);
    },
    tagValidatoraoe(tag) {
      return !this.user.roles.panelaoe.includes(tag.toLowerCase());
    },
    tagValidatorskill(tag) {
      return !this.user.roles.panelSkills.includes(tag.toLowerCase());
    },
    async checkPanelist() {
      this.$v.user.emailid.$touch();
      if (!this.$v.user.emailid.$invalid) {
        try {
          let payload = {
            email: this.user.emailid,
          };
          const res = await checkPanelExists(payload);

          if (res.status == 200) {
            this.panelExists = true;
            if (this.userStatus == "Edit") this.showPanelData = true;
            this.panelId = res.data.data.panelID;
            this.user.roles.panelPhone = res.data.data.phoneNumber;
            this.user.roles.panelaoe = res.data.data.areaOfExpertise.map(
              (obj) => {
                return obj.name;
              }
            );
            this.user.roles.panelSkills = res.data.data.skills.map((obj) => {
              return obj.name;
            });
          }
        } catch (error) {
          console.error(error);
        }
      }
    },
    checkRoleEdit(role) {
      return (
        role == "Panelist" ||
        role == "BU Head" ||
        role == "Admin" ||
        role == "Lead Recruiter" ||
        role == "Recruiter" ||
        role == "External Client" ||
        role == "Hiring Manager"
      );
    },
    updatePage(value) {
      this.count = value;
      this.currentPage = 1;
      this.LoaderStatus = true;
      this.getAccessData();
    },
    onBackspace(event) {
      if (
        event.target.selectionStart === event.target.selectionEnd &&
        event.target.selectionStart === 0
      ) {
        if (this.user.roles.panelaoe && this.user.roles.panelaoe.length > 0) {
          // this.onDelChk(this.user.roles.panelaoe[this.user.roles.panelaoe.length-1])
        }
      }
    },
    resetRoleData() {
      this.allRoles = this.allRoles.map((module) => ({
        ...module,
        collapseOpen: false,
        ...(module.submodules && {
          submodules: module.submodules.map((submodule) => ({
            ...submodule,
            subcollapseOpen: false,
          })),
        }),
      }));
    },
    setLandingPage(val) {
      this.user.roles.landingPage = val.value;
      this.user.roles.dashboard = val.text;
      this.showLandingError = false;
    },
    getRoleNames(values) {
      let rolevalue = values.map((value) => {
        return value.roleName;
      });
      return rolevalue.join(" + ");
    },
    hideUserFilterDropdown() {
      this.showMainFilter = false;
      this.showFilterOptions = false;
    },
    sortData(col, ordr, type) {
      this.sortBy = col;
      this.order = ordr;
      this.LoaderStatus = true;
      type == "user" ? this.getAccessData() : this.getRolesDetails();
    },
    NumbersOnly(evt) {
      NumbersOnly(evt);
    },
    goToPages() {
      this.currentPage = Math.min(Math.max(1, this.goToPage), this.totalPages);
      this.goToPage = null;
    },
    getRoleCount(smodule, type) {
      let count = 0;
      this.filteredRoles.forEach((module) => {
        if (module.name == smodule.name) {
          if (module.roles.length > 0) {
            count +=
              type == "selected"
                ? module.roles.filter((role) =>
                    this.roles_array.includes(role.value)
                  ).length
                : module.roles.length;
          } else {
            module.submodules.forEach((submodule) => {
              count +=
                type == "selected"
                  ? submodule.roles.filter((role) =>
                      this.roles_array.includes(role.value)
                    ).length
                  : submodule.roles.length;
            });
          }
        }
      });
      return count;
    },
    checkRoleMatch(module) {
      if (module.roles && Array.isArray(module.roles)) {
        if (
          module.roles.some((role) =>
            role.text.toLowerCase().includes(this.searchTerm.toLowerCase())
          )
        ) {
          return true;
        }
      }
    },
    filterRolesonSelectedFilter(filteredModules) {
      return filteredModules
        .map((module) => {
          const filteredModule = {
            ...module,
            roles: module.roles
              ? module.roles.filter((role) =>
                  this.selectedFilter.includes(role.type)
                )
              : [],
            submodules: module.submodules
              ? this.filterRolesonSelectedFilter(module.submodules)
              : [],
          };
          return filteredModule.roles.length > 0 ||
            filteredModule.submodules.length > 0
            ? filteredModule
            : null;
        })
        .filter((module) => module !== null);
    },
    // Set tabIndex based on the query variables (check watcher)
    setTabIndex() {
      if (this.$route.query.structure) {
        this.checkboxval = !!this.$route.query.structure;
      }
      // console.log(this.roleValues, '***********8');
      //checking user roles
      if (
        this.rolesdata.includes("GET_ROLE") &&
        !this.rolesdata.includes("VIEW_ADMIN") &&
        !this.rolesdata.includes("SUB_ADMIN")
      ) {
        this.tabName = "roles";
      } else if (
        (this.rolesdata.includes("VIEW_ADMIN") ||
          this.rolesdata.includes("SUB_ADMIN")) &&
        !this.rolesdata.includes("GET_ROLE")
      ) {
        this.tabName = "users";
      } else {
        this.tabName = "users";
      }
      if (
        this.$route.query.status &&
        (this.rolesdata.includes("VIEW_ADMIN") ||
          this.rolesdata.includes("SUB_ADMIN")) &&
        this.rolesdata.includes("GET_ROLE")
      ) {
        this.tabName = this.$route.query.status;
      }
      switch (this.$route.query.status) {
        case "users":
          this.tabIndex = 0;
          break;
        case "roles":
          this.tabIndex = 1;
          break;
        default:
          this.tabIndex = 0;
      }
    },
    //Methods for color binding
    getAccessColorClass(item) {
      const roles =
        item.roles.length > 0
          ? item.roles
          : item.submodules.flatMap((submodule) => submodule.roles);
      const hasSelectedRoles = roles.some((role) =>
        this.roles_array.includes(role.value)
      );
      return hasSelectedRoles ? "access-color" : "";
    },
    setSearchValue() {
      if (this.tabName == "users") {
        this.$store.commit("accessControlVUEX/saveSearchTab", "Users");
        this.$store.commit("searchVUEX/saveSearchQuery", "");
      } else {
        this.$store.commit("accessControlVUEX/saveSearchTab", "Roles");
        this.$store.commit("searchVUEX/saveSearchQuery", "");
      }
    },
    updateSubmoduleViews() {
      this.filteredRoles.forEach((module) => {
        if (module.submodules != undefined) {
          module.submodules.forEach((submodule) => {
            submodule.submodView = this.areAllSubmoduleRolesSelected(submodule);
          });
        }
      });
    },
    filterSubmoduleViews() {
      this.filteredRoles.forEach((module, index1) => {
        const collapseRef = this.$refs[`collapse${index1}`];
        if (collapseRef && collapseRef[0]) {
          collapseRef.forEach((element) => {
            element.show = false;
          });
        }
        module.collapseOpen = false;
        if (module.submodules != undefined) {
          module.submodules.forEach((submodule, index2) => {
            const collapseRef = this.$refs[`collapse-2${index1 + index2}`];

            if (collapseRef && collapseRef[0]) {
              collapseRef.forEach((element) => {
                element.show = false;
              });
            }
            submodule.subcollapseOpen = false;
            submodule.submodView = this.areAllSubmoduleRolesSelected(submodule);
          });
        }
      });
    },
    areAllSubmoduleRolesSelected(submodule) {
      return submodule.roles.every((role) =>
        this.roles_array.includes(role.value)
      );
    },
    // To Select dashboard based on Selected Roles
    selectMultipleRoles() {
      // Storing roles values in single array
      const storeRoleValues = this.roleDropDownValue.flatMap(
        (item) => item.roles
      );
      // Creating new Set by removing duplicates of roles permission
      this.newRoleValues = [...new Set(storeRoleValues)];
      if (
        this.newRoleValues.includes("RECRUITER_VIEW") ||
        this.newRoleValues.includes("JOB_VIEW")
      ) {
        this.newRoleValues.push("JOB_DASHBOARD");
      }
      //  Dashboard Roles Values
      const dashboard = {
        "Dashboard (Recommended)": "VIEW_DASHBOARD",
        "Job Dashboard": "JOB_DASHBOARD",
        Workbench: "GET_WORKBENCH",
        "Manage - Customer": "GET_CUSTOMER",
        "Manage - Vendor": "GET_VENDOR",
        "User Management - User": "VIEW_ADMIN",
        "User Management - Role": "GET_ROLE",
        Panelist: "GET_PANEL",
        "Panelist Dashboard": "GET_PANEL_DASHBOARD",
        "Talent Pool": "GET_TALENTPOOL",
        "Interview Process": "GET_INTERVIEW",
        "Feedback Form": "GET_FEEDBACK_FORM",
        "HR Portal": "GET_HRPORTAL",
        "Job Approval": "GET_JD_APPROVAL",
        "Candidate Approval": "GET_ACCEPT_CANDIDATE",
        "CV Search": "GET_CV_SEARCH",
        "Custom Field": "GET_FORM",
        "Third Party": "GET_THIRD_PARTY",
        Transactions: "GET_TRANSACTIONS",
        Teams: "GET_TEAMS",

        // Admin: "VIEW_ADMIN",
        // HR: "GET_HRPORTAL",
        // OpsHead: "GET_JD_APPROVAL",
        // "Candidate Approval": "GET_ACCEPT_CANDIDATE",

        Vendor: "GET_VENDOR_DASHBOARD",
      };

      // Finding matched values
      const res = Object.entries(dashboard)
        // eslint-disable-next-line
        .filter(([key, value]) => this.newRoleValues.includes(value))
        .map(([key]) => key);
      // Dashboard Values
      const options = [
        { text: "Dashboard (Recommended)", value: "/my-board" },
        { text: "Job Dashboard", value: "/jobdashboard" },
        { text: "Workbench", value: "/" },
        { text: "Manage - Customer", value: "/data/manage?status=customer" },
        { text: "Manage - Vendor", value: "/data/manage?status=manage" },
        { text: "User Management - User", value: "/permission/access" },
        {
          text: "User Management - Role",
          value: "/permission/access?status=roles",
        },
        { text: "Panelist", value: "/permission/panel/list" },
        { text: "Panelist Dashboard", value: "/panellogin" },
        { text: "Talent Pool", value: "/talentpool/" },
        { text: "Reports", value: "/report/" },
        {
          text: "Interview Process",
          value: "/hiringprocess/dashboard?status=interviewProcess",
        },
        {
          text: "Feedback Form",
          value: "/hiringprocess/dashboard?status=feedbackForm",
        },
        { text: "HR Portal", value: "/hr/dashboard" },
        { text: "Job Approval", value: "/approval/viewjds" },
        { text: "Candidate Approval", value: "/approval/reviewcandidates" },
        { text: "CV Search", value: "/search/profiles" },
        { text: "Custom Field", value: "/customfield/customform" },
        { text: "Third Party", value: "/thirdparty/home" },
        { text: "Transactions", value: "/transactions" },
        { text: "Teams", value: "/teams" },
        // { text: "OpsHead", value: "/approval/viewjds" },

        // { text: "Admin", value: "/permission/access" },
        { text: "Vendor", value: "/vendorlogin" },
      ];

      // assigning dashboard values based on permission selected
      this.dashboardOptions = options.filter(
        (option) =>
          res.includes(option.text) ||
          (option.text == "Reports" && this.checkForReports)
      );
      this.user.roles.dashboard = "";
      this.user.roles.landingPage = "";
    },

    // Select Or All Roles vaules
    AllRolSelect() {
      if (this.selectAll) {
        this.filteredRoles.forEach((module, i) => {
          module.roles.forEach((role) => {
            if (!this.roles_array.includes(role.value)) {
              this.roles_array.push(role.value);
            }
          });
          this.roleSelect(i);
        });
      } else {
        this.roles_array = [];
      }
    },
    roleSelect(i) {
      if (this.filteredRoles[i].submodules) {
        this.filteredRoles[i].submodules.forEach((submodule) => {
          submodule.roles.forEach((role) => {
            if (!this.roles_array.includes(role.value)) {
              this.roles_array.push(role.value);
            }
          });
        });
      }
    },

    checkSelectAll() {
      const isSelectedAll = this.filteredRoles.length > 0 && this.checkRole();
      this.$nextTick(() => {
        this.selectAll = isSelectedAll;
      });
    },
    checkRole() {
      for (let module of this.filteredRoles) {
        if (
          module.roles.length > 0 &&
          !module.roles.every((role) => this.roles_array.includes(role.value))
        ) {
          return false;
        }
        if (
          module.submodules &&
          Array.isArray(module.submodules) &&
          module.submodules.length > 0
        ) {
          for (let submodule of module.submodules) {
            if (
              submodule.roles.length > 0 &&
              !submodule.roles.every((role) =>
                this.roles_array.includes(role.value)
              )
            ) {
              return false;
            }
          }
        }
      }
      return true;
    },
    selectSubRolVal(subrole) {
      for (let k in subrole.roles) {
        if (!this.roles_array.includes(subrole.roles[k].value)) {
          this.roles_array.push(subrole.roles[k].value);
        } else {
          this.roles_array = this.roles_array.filter(function (item) {
            return item !== subrole.roles[k].value;
          });
        }
      }
    },
    selectSubRole(submodule) {
      if (submodule.submodView) {
        for (let j in submodule.roles) {
          if (!this.roles_array.includes(submodule.roles[j].value)) {
            this.roles_array.push(submodule.roles[j].value);
          }
        }
      } else {
        for (let i in submodule.roles) {
          this.roles_array = this.roles_array.filter(function (item) {
            return item !== submodule.roles[i].value;
          });
        }
      }
    },
    selectRolVal(moduleroles, allRoles) {
      for (let k in moduleroles.roles) {
        if (!this.roles_array.includes(moduleroles.roles[k].value)) {
          this.roles_array.push(moduleroles.roles[k].value);
        } else {
          this.roles_array = this.roles_array.filter(function (item) {
            return item !== moduleroles.roles[k].value;
          });
        }
      }
      if (
        moduleroles.value == "GET_REPORT_MANAGEMENT" &&
        this.roles_array.includes("GET_REPORT_MANAGEMENT")
      ) {
        for (let i of allRoles) {
          if (
            i.value != "GET_REPORT_MANAGEMENT" &&
            !this.roles_array.includes(i.value)
          ) {
            this.roles_array.push(i.value);
          }
        }
      } else if (this.roles_array.includes("GET_REPORT_MANAGEMENT")) {
        for (let i of allRoles) {
          if (
            i.value != "GET_REPORT_MANAGEMENT" &&
            !this.roles_array.includes(i.value)
          ) {
            this.roles_array.push(i.value);
          }
        }
      }
    },
    selectrole(module) {
      if (module.roleView) {
        module.roles.forEach((role) => {
          if (!this.roles_array.includes(role.value)) {
            this.roles_array.push(role.value);
          }
        });
        this.checkSelectRole(module);
      } else {
        module.roles.forEach((role) => {
          this.roles_array = this.roles_array.filter(
            (item) => item !== role.value
          );
        });
        module.submodules &&
          module.submodules.forEach((submodule) => {
            submodule.roles.forEach((role) => {
              this.roles_array = this.roles_array.filter(
                (item) => item !== role.value
              );
            });
          });
      }
    },

    checkSelectRole(module) {
      if (module.submodules !== undefined) {
        module.submodules.forEach((submodule) => {
          submodule.roles.forEach((role) => {
            if (!this.roles_array.includes(role.value)) {
              this.roles_array.push(role.value);
            }
          });
        });
      }
    },
    // Scroll to bottom when Add new User button is clicked
    // scrollToBottom() {
    //   this.$nextTick(() => {
    //     const scrollContainer = document.getElementById("scrollTobottomUser");
    //     const userCont = document.getElementById("addUserContainer");
    //     scrollContainer.scrollTo({
    //       top: scrollContainer.scrollHeight - userCont.offsetHeight,
    //       left: 0,
    //       behavior: "smooth",
    //     });
    //   });
    // },
    scrolltopUser() {
      const element = document.getElementById("scrollToUser");
      element.scrollTop = 0;
    },
    scrolltopRole() {
      const element = document.getElementById("scrollToRole");
      element.scrollTop = 0;
    },
    // scrollToBottomRole() {
    //   this.$nextTick(() => {
    //     const scrollContainer = document.getElementById("scrollTobottomRole");
    //     const roleCont = document.getElementById("addRoleContainer");
    //     scrollContainer.scrollTo({
    //       top: scrollContainer.scrollHeight - roleCont.offsetHeight,
    //       left: 0,
    //       behavior: "smooth",
    //     });
    //   });
    // },
    async addPanelist(id) {
      let roleValue = this.roleDropDownValue.filter(
        (d) => d.roleName != "Panelist"
      );
      this.aoetags.expertise = this.user.roles.panelaoe;
      this.skillstags.skill = this.user.roles.panelSkills;
      const aoegrid = this.user.roles.panelaoe.map((tag) => ({
        name: tag,
        code: tag,
      }));
      const skillgrid = this.user.roles.panelSkills.map((tag) => ({
        name: tag,
        code: tag,
      }));
      let panelPayload = {
        roles: roleValue.map((d) => d.roleName),
        name: this.user.name,
        phoneNumber: this.user.roles.panelPhone,
        email: this.user.emailid,
        skills: skillgrid,
        areaOfExpertise: aoegrid,
        subAdmin: this.user.subAdmin,
        subAdminRoles: this.user.subAdmin
          ? this.subAdminRoleDropDownValue.map((d) => d._id)
          : [],
      };
      if (id) {
        panelPayload.panelID = this.panelId;
        panelPayload.active = true;
      }
      let val = id ? "fromEdit" : "fromAdd";
      await handlePanelData(this, val, panelPayload, "hide");
    },
    // Post User Api
    async addUser() {
      this.$v.user.$touch();
      this.$v.roleDropDownValue.$touch();
      this.$v.subAdminRoleDropDownValue.$touch();
      if (
        this.$v.user.$error ||
        this.$v.roleDropDownValue.$error ||
        this.$v.subAdminRoleDropDownValue.$error
      ) {
        if (!this.user.roles.landingPage) {
          this.showLandingError = true;
        }
        this.errorModal("Please enter all the details");
      } else if (
        !this.$v.user.$invalid ||
        this.$v.roleDropDownValue.$invalid ||
        this.$v.subAdminRoleDropDownValue.$invalid
      ) {
        this.LoaderStatus = true;
        this.showLandingError = false;
        if (this.showPanelDetails && !this.panelExists) {
          await this.addPanelist();
        } else if (this.showPanelDetails && this.panelExists) {
          await this.addPanelist(this.panelId);
        } else {
          await this.addNewUser();
        }

        if (!this.panelFailure && this.showPanelDetails) {
          this.dynamicToast(
            "success",
            `Successfully added`,
            "New user has been added."
          );
          this.addUserForm = false;
          this.getAccessData();
          this.scrolltopUser();
          this.LoaderStatus = false;
          this.clearUserFormData();
          this.$v.user.$reset();
          this.$v.roleDropDownValue.$reset();
          this.$v.subAdminRoleDropDownValue.$reset();
          // await this.addNewUser();
        }
        this.LoaderStatus = false;
        // else {
        //   this.errorModal("Something went wrong!");
        // }
      }
    },
    async addNewUser() {
      try {
        let payload = {
          email: this.user.emailid,
        };
        const res = await userToLicenseData(payload);
        if (res.status == 200) {
          let obj = {
            username: this.user.name,
            email: this.user.emailid,
            // roleName: this.user.roles.roleName,
            roles: this.roleDropDownValue.map((d) => d.roleName),
            landingPage: this.user.roles.landingPage,
            isActive: true,
            subAdmin: this.user.subAdmin,
            subAdminRoles: this.user.subAdmin
              ? this.subAdminRoleDropDownValue.map((d) => d._id)
              : [],
          };
          let payloadOne = {
            project: "recruitment",
            action: "add",
            licenseKey: this.licenseKey,
            userPermissions: [obj],
          };
          const response = await postAccessData(payloadOne);
          if (response.status == 200) {
            this.dynamicToast(
              "success",
              `Successfully added`,
              "New user has been added."
            );
            this.addUserForm = false;
            this.getAccessData();
            this.scrolltopUser();
            this.LoaderStatus = false;
            this.clearUserFormData();
            this.$v.user.$reset();
            this.$v.roleDropDownValue.$reset();
            this.$v.subAdminRoleDropDownValue.$reset();
          } else if (response.status == 208) {
            this.LoaderStatus = false;
            this.errorModal(`User already exists for this emailID`);
            this.$nextTick(() => {
              this.$v.roleDropDownValue.$reset();
              this.$v.subAdminRoleDropDownValue.$reset();
            });
          } else if (response.status == 409) {
            let errorMessage = response.data.data.Details;
            this.errorModal(`${errorMessage}`);
            this.LoaderStatus = false;
          } else {
            this.LoaderStatus = false;
            this.errorModal("Something went wrong!");
            this.$nextTick(() => {
              this.$v.roleDropDownValue.$reset();
              this.$v.subAdminRoleDropDownValue.$reset();
            });
          }
          // return response;
        } else {
          this.errorModal("Something went wrong!");
          this.LoaderStatus = false;
          throw new Error(`Failed! Role Not Added`);
        }
      } catch (error) {
        this.LoaderStatus = false;
        this.errorModal("Something went wrong!");
        throw new Error(`Adding User Failed! status: ${error.status}`);
      }
    },
    // Get User Api
    async getAccessData() {
      try {
        let data = {
          project: "recruitment",
          value: "ALL",
          licenseKey: this.licenseKey,
          searchQuery: this.searchQuery,
          page: this.currentPage - 1,
          count: this.count,
          subAdmin: this.roleValues.subAdmin,
        };
        if (this.sortBy) {
          (data.sortBy = this.sortBy), (data.order = this.order);
        }
        if (this.filter) {
          data.filter = this.filter;
        }
        const res = await getUserAccessData(data);
        if (res.status == 200) {
          this.rowData = await res.data.data.data;
          this.pageStart = res.data.data.pageStart;
          this.pageEnd = res.data.data.pageEnd;
          this.total = res.data.data.total;
          for (let i in this.rowData) {
            this.rowData[i].view = false;
          }
        }
        this.LoaderStatus = false;
      } catch (error) {
        this.LoaderStatus = false;
        throw new Error(`Failed! status:${error.status}`);
      }
    },
    // Edit User Api
    async editUser() {
      this.$v.user.$touch();
      this.$v.roleDropDownValue.$touch();
      this.$v.subAdminRoleDropDownValue.$touch();
      if (
        this.$v.user.$error ||
        this.$v.roleDropDownValue.$error ||
        this.showLandingError ||
        this.$v.subAdminRoleDropDownValue.$error
      ) {
        if (!this.user.roles.landingPage) {
          this.showLandingError = true;
        }
        this.errorModal("Please enter all the details");
      } else if (
        !this.$v.user.$invalid ||
        this.$v.roleDropDownValue.$invalid ||
        this.$v.subAdminRoleDropDownValue.$invalid
      ) {
        this.showLandingError = false;
        this.LoaderStatus = true;
        if (this.showPanelDetails && !this.panelExists) {
          await this.addPanelist();
        } else if (
          (this.showPanelDetails && this.panelExists) ||
          this.showPanelData
        ) {
          await this.addPanelist(this.panelId);
        } else {
          await this.editUserData();
        }
        if (
          !this.panelFailure &&
          (this.showPanelDetails || this.showPanelData)
        ) {
          await this.editUserData();
        } else {
          this.LoaderStatus = false;
        }
      }
    },
    async editUserData() {
      let obj = {
        username: this.user.name,
        email: this.user.emailid,
        // roleName: this.user.roles.roleName,
        roles: this.roleDropDownValue.map((d) => d.roleName),
        landingPage: this.user.roles.landingPage,
        userID: this.selectedUserID,
        isActive: true,
        subAdmin: this.roleValues.subAdmin ? false : this.user.subAdmin,
        subAdminRoles: this.roleValues.subAdmin
          ? []
          : this.user.subAdmin
          ? this.subAdminRoleDropDownValue.map((d) => d._id)
          : [],
      };
      let payload = {
        project: "recruitment",
        action: "add",
        licenseKey: this.licenseKey,
        userPermissions: [obj],
      };
      try {
        const response = await putAccessData(payload);
        if (response.status == 200) {
          this.dynamicToast(
            "success",
            `Successfully updated`,
            "User has been updated."
          );
          this.addUserForm = false;
          this.userStatus = "Add";
          this.getAccessData();
        } else {
          this.errorModal("Something went wrong!");
        }
        this.LoaderStatus = false;
      } catch (error) {
        this.LoaderStatus = false;
        this.errorModal("Something went wrong!");
        throw new Error(`Failed! Updating Users! status: ${error.status}`);
      }
      this.clearUserFormData();
      this.$v.user.$reset();
      this.$v.roleDropDownValue.$reset();
      this.$v.subAdminRoleDropDownValue.$reset();
    },
    // Delete User Api
    async deleteUser(data) {
      this.$bvModal.hide("delete-user-modal");
      let payload = {
        project: "recruitment",
        userID: data.userID,
        licenseKey: this.licenseKey,
      };
      try {
        const response = await deleteAccessData(payload);
        if (response.status == 200) {
          this.removeDeleteUserData(data.email);
          this.dynamicToast(
            "success",
            `Successfully deleted`,
            "User has been deleted."
          );
        } else {
          this.errorModal("Something went wrong!");
        }
      } catch (error) {
        this.errorModal("Something went wrong!");
        throw new Error(`Failed! status:${error.status}`);
      }
    },
    copyEditUserData(row) {
      this.userRoles = row;
      this.addUserForm = true;
      this.user["name"] = row.username;
      this.user["emailid"] = row.email;

      // this.user.roles["roleName"] = row.roles;
      this.user.subAdmin = row.subAdmin;
      this.user.subAdminRoles = row.subAdminRoles;
      this.selectedUserID = row.userID;
      this.userStatus = "Edit";
      this.roleDropDownValue = [];
      this.subAdminRoleDropDownValue = [];
      this.showPanelData = false;
      for (let roleName of row.roles) {
        // if (this.roleValues.subAdmin) {
        //   matchingRole = this.rolesoptions.find(
        //     (option) =>
        //       option.roleName === roleName &&
        //       this.roleValues.subAdminRoles.includes(option.roleName)
        //   );
        // } else {
        const matchingRole = this.rolesoptions.find(
          (option) => option.roleName === roleName
        );
        // }
        if (matchingRole) {
          matchingRole.project = "recruitment";
          this.roleDropDownValue.push(matchingRole);
        }
      }
      for (let roleName of row.subAdminRoles) {
        const matchingRole = this.rolesoptions.find(
          (option) => option.roleName === roleName
        );
        if (matchingRole) {
          matchingRole.project = "recruitment";
          this.subAdminRoleDropDownValue.push(matchingRole);
        }
      }
      this.selectMultipleRoles();
      this.user.roles["dashboard"] =
        this.showDashboardText(row.landingPage) == "Dashboard"
          ? "Dashboard (Recommended)"
          : this.showDashboardText(row.landingPage);
      this.user.roles["landingPage"] = row.landingPage;
      this.viewusercontainer = false;
      if (this.dashboardOptions.length == 0) {
        this.showLandingError = true;
      }
    },
    emailChange(event) {
      const input = event.target;
      const start = input.selectionStart;
      const end = input.selectionEnd;
      this.user.emailid = input.value.toLowerCase();
      this.$nextTick(() => {
        input.setSelectionRange(start, end);
      });
    },
    copyEditRoles(data) {
      this.resetRoleData();
      const result = data || this.storeData;
      this.viewrolecontainer = false;
      this.rolecontainer = true;
      this.rolesData = JSON.parse(JSON.stringify(result));
      this.roles_array = JSON.parse(JSON.stringify(result.roles));
      this.roleStatus = "Edit";
    },
    clearEditRoles() {
      this.roles_array = [];
      this.searchTerm = "";
      this.selectedFilter = [];
    },
    openUserDeleteModal(data) {
      this.deleteUserData = data;
      this.$bvModal.show("delete-user-modal");
    },
    // Post roles
    postRoles() {
      this.$v.rolesData.$touch();
      if (!this.roles_array.length) {
        this.errorModal("Please select any one permissions");
      } else if (this.$v.rolesData.roleName.$invalid) {
        this.errorModal("Please enter all the details");
      } else if (!this.$v.rolesData.$invalid) {
        this.LoaderStatus = true;
        this.rolesData["roles"] = this.roles_array;
        this.rolesData["licenseKey"] = this.licenseKey;
        this.rolesData["view"] = false;
        let data = this.rolesData;
        postRoles(data)
          .then((res) => {
            if (res.status == 200) {
              this.LoaderStatus = false;
              this.roleData.unshift(data);
              this.dynamicToast(
                "success",
                `Successfully added`,
                "New role has been added."
              );
              this.rolecontainer = false;
              this.roles_options_checked = false;
              this.scrolltopRole();
              this.clearEditRoles();
              this.clearRolesFormData();
              this.$v.rolesData.$reset();
              this.LoaderStatus = true;
              this.getRolesDetails(true);
            } else if (res.status == 208) {
              this.LoaderStatus = false;
              this.errorModal("Role with the same name already exists!");
            } else {
              this.LoaderStatus = false;
              this.errorModal("Something went wrong!");
            }
          })
          .catch((err) => {
            this.errorModal("Something went wrong!");
            this.LoaderStatus = false;
            throw err;
          });
      }
    },
    getOnlyExistingRoles() {
      let values = this.role_options.map((obj) => {
        return obj.value;
      });
      return this.roles_array.filter((obj) => {
        if (values.includes(obj)) {
          return obj;
        }
      });
    },

    // Edit roles
    async editRoles() {
      this.roles_array = this.getOnlyExistingRoles();
      if (!this.roles_array.length) {
        this.errorModal("Please select any one permissions");
      } else {
        this.rolesData["roles"] = this.roles_array;
        this.rolesData["projectPermission"] = "1";
        this.rolesData["licenseKey"] = this.licenseKey;
        let data = this.rolesData;

        try {
          const response = await putRoles(data);
          if (response.status == 200) {
            // this.updateRoleData(data);
            this.dynamicToast(
              "success",
              `Successfully updated`,
              "Role has been updated."
            );
            this.rolecontainer = false;
            this.roleStatus = "Add";
            this.LoaderStatus = true;
            this.getRolesDetails(true);
          } else {
            this.errorModal("Something went wrong!");
          }
        } catch (error) {
          this.errorModal("Something went wrong!");
          throw new Error(`Failed! Updating Roles:${error.status}`);
        }
        this.clearRolesFormData();
      }
    },

    async getRolesDetails(val) {
      try {
        let params = {
          project: "recruitment",
          type: "ALLROLES",
          licenseKey: this.licenseKey,
          searchQuery: this.searchQuery,
          roles: val ? true : this.tabName == "users" ? false : true,
        };
        if (this.sortBy) {
          params.sortBy = this.sortBy;
          params.order = this.order;
        }
        const res = await getRolesDetails(params);
        if (res.status == 200) {
          this.roleData = await res.data.data.data;
          if (val) {
            this.userRoleData = res.data.data.data;
          } else {
            this.rolesoptions = res.data.data.data;
          }
          for (let role of this.roleData) {
            role.view = false;
            for (let user of role.users) {
              const username = user.userPermissions.username;
              const initials = username.includes(" ")
                ? username
                    .split(" ")
                    .map((name) => name && name[0].toUpperCase())
                    .join("")
                : username.slice(0, 2).toUpperCase();
              user.userPermissions.userIcon = initials;
            }
          }
        }
        this.LoaderStatus = false;
      } catch (error) {
        this.LoaderStatus = false;
        throw new Error(`Failed! status:${error.status}`);
      }
    },
    viewrole(data) {
      this.storeData = data;
      this.viewrolecontainer = true;
      this.roleName = data.roleName;
      this.description = data.description;
      this.project = data.project;
      this.roles = data.roles;
      this.roles_array = data.roles;
      this.$forceUpdate();
    },
    viewUser(data) {
      this.storeuser = data;
      this.viewusercontainer = true;
    },
    resetStatus() {
      this.userStatus = "Add";
    },
    resetroleStatus() {
      this.roleStatus = "Add";
    },

    // Open Role Delete Modal
    openRoleDeleteModal(data) {
      this.deleteRolesData = data;
      this.$bvModal.show("delete-role-modal");
    },
    // Delete Roles Api
    async deleteRoles(data) {
      this.$bvModal.hide("delete-role-modal");
      try {
        let payload = {
          project: "recruitment",
          roleName: data.roleName,
          licenseKey: this.licenseKey,
          description: data.description,
        };
        const response = await deleteRoles(payload);
        if (response.status == 200) {
          // this.removeDeleteRoleData(data.roleName);
          this.dynamicToast(
            "success",
            `Successfully deleted`,
            "Role has been deleted."
          );
          this.LoaderStatus = true;
          this.getRolesDetails(true);
        } else if (response.status == 409) {
          let errorMessage = response.data.data.data;
          this.errorModal(`${errorMessage}`);
        } else {
          this.errorModal("Something went wrong!");
        }
      } catch (error) {
        this.errorModal("Something went wrong!");
        throw new Error(`Failed! status:${error.status}`);
      }
    },

    // remove delete role data from roleData & rolesoptions array without reloading
    removeDeleteRoleData(payload) {
      this.roleData = this.roleData.filter((data) => data.roleName != payload);
      this.rolesoptions = this.rolesoptions.filter(
        (data) => data.roleName != payload
      );
    },
    // remove delete user data from rowData array without reloading
    removeDeleteUserData(payload) {
      this.rowData = this.rowData.filter((data) => data.email != payload);
    },
    // update edit data from roleData array without reloading
    updateRoleData(payload) {
      for (let i in this.roleData) {
        if (this.roleData[i].roleName === payload.roleName) {
          // Copying the OBJECT
          this.roleData[i] = { ...payload };
        }
      }
    },
    hidefiltercard() {
      this.filterview = false;
    },
    roleDropdown() {
      this.selectroleview = !this.selectroleview;
      this.searchrec = "";
    },
    hideroleDropdown() {
      this.selectroleview = false;
      this.searchrec = "";
    },
    closeTransition() {
      this.addUserForm = false;
      this.viewusercontainer = false;
      this.viewrolecontainer = false;
      this.rolecontainer = false;
      this.currentPage = 1;
      this.total = 0;
      this.pageStart = null;
      this.pageEnd = null;
      this.order = null;
      this.sortBy = "";
      this.userStatus = "Add";
      this.roleStatus = "Add";
      this.selectedRole = "";
      this.filter = "";
      this.hideUserFilterDropdown();
      if (this.tabName == "roles") {
        this.LoaderStatus = true;
        this.getRolesDetails();
      } else {
        this.LoaderStatus = true;
        this.getAccessData();
        this.getRolesDetails();
        this.getRolesDetails(true);
      }
    },
    // clearing role models
    clearRolesFormData() {
      this.$v.$reset();
      this.rolesData = {
        roleName: "",
        description: "",
        licenseKey: "",
        project: "recruitment",
        projectPermission: "1",
        roles: [],
      };
      this.roles_array = [];
      this.searchTerm = "";
      this.selectedFilter = [];
    },
    // clearing user models
    clearUserFormData() {
      this.$v.$reset();
      this.panelExists = false;
      this.panelFailure = false;
      this.showPanelDetails = false;
      this.user = {
        name: "",
        emailid: "",
        summary: "",
        subAdmin: false,
        roles: {
          roleName: "",
          description: "",
          roles: [],
          landingPage: "",
          dashboard: "",
          panelPhone: null,
          panelaoe: [],
          panelSkills: [],
        },
      };
      this.showPanelData = false;
      this.showLandingError = false;
      this.roleDropDownValue = [];
      this.subAdminRoleDropDownValue = [];
      this.selectedUserID = "";
      this.dashboardOptions = [];
      this.newRoleValues = [];
      this.searchrec = "";
    },
    showDashboardText(data) {
      if (data == "/") {
        return "Workbench";
      } else if (data == "/jobdashboard") {
        return "Job Dashboard";
      } else if (data == "/my-board") {
        return "Dashboard";
      } else if (data == "/permission/access") {
        return "User Management - User";
      } else if (data == "/hr/dashboard") {
        return "HR Portal";
      } else if (data == "/approval/viewjds") {
        return "Job Approval";
      } else if (data == "/approval/reviewcandidates") {
        return "Candidate Approval";
      } else if (data == "/panellogin") {
        return "Panelist Dashboard";
      } else if (data == "/permission/panel/list") {
        return "Panelist";
      } else if (data == "/vendorlogin") {
        return "Vendor";
      } else if (data == "/permission/access?status=roles") {
        return "User Management - Role";
      } else if (data == "/data/manage?status=customer") {
        return "Manage - Customer";
      } else if (data == "/data/manage?status=manage") {
        return "Manage - Vendor";
      } else if (data == "/talentpool/") {
        return "Talent Pool";
      } else if (data == "/report/") {
        return "Reports";
      } else if (data == "/hiringprocess/dashboard?status=interviewProcess") {
        return "Interview Process";
      } else if (data == "/hiringprocess/dashboard?status=feedbackForm") {
        return "Feedback Form";
      } else if (data == "/search/profiles") {
        return "CV Search";
      } else if (data == "/customfield/customform") {
        return "Custom Field";
      } else if (data == "/thirdparty/home") {
        return "Third Party";
      } else if (data == "/teams") {
        return "Teams";
      } else if (data == "/transactions") {
        return "Transactions";
      } else {
        return "None";
      }
    },
  },
};
</script>

<style>
.acc-work-container {
  height: 94%;
  margin-top: 15px;
  background: #ffffff;
  box-shadow: 0px 0px 14px rgb(196 196 196 / 50%);
  border-radius: 10px;
}
.partial-select .custom-switch .custom-control-label::after {
  background-color: #83aace !important ;
}
.role-switch-label {
  color: #545454;
  font-weight: 400;
  font-size: 14px;
}
.addroleswitch
  .custom-border
  .custom-control-input:checked
  ~ .custom-control-label::before {
  color: #fff;
  border: 1px solid #ffffff !important;
}
.addroleswitch .custom-control-input:checked ~ .custom-control-label::before {
  color: #fff;
  border-color: #72738e;
  background-color: #4b80af;
}
.tab-container-ac {
  height: calc(100vh - 280px);
  overflow: auto;
}
.collapsed > .when-open,
.not-collapsed > .when-closed {
  display: none;
}

/* .accesscontrol-closed-br {
  border-radius: 5px !important;
} */
.prevliage-text {
  font-weight: 400;
  font-size: 14px;
  color: #72738e;
}
.access-opened-box {
  background: #ffffff;
  box-shadow: 0px 4px 15px rgba(196, 196, 196, 0.5);
  border-radius: 5px;
  padding: 15px;
  font-weight: 400;
  font-size: 12px;
  margin-top: 10px;
  color: #545454;
}
.access-opened-contentbox {
  min-height: 100px;
  max-height: 320px;
  overflow-x: hidden;

  overflow-y: auto;
}

.acss-bg-colors:nth-child(odd) {
  background: #f4f4f4;
  padding: 2px;
}
.acss-bg-colors:nth-child(even) {
  background: #fdfdfd;
  padding: 2px;
}
.access-outerbox {
  font-weight: 400;
  font-size: 14px;
  font-family: "lato", sans-serif;
  color: #000000;
  padding: 12px 15px;
  background: #ffffff;
  box-shadow: 0px 4px 15px rgba(196, 196, 196, 0.5);
  border-radius: 5px;
}

.access-outerbox .custom-control-label {
  color: #000000;
  font-weight: 400;
  font-size: 14px;
  font-family: "lato", sans-serif;
}

.custom-switch .custom-control-label {
  color: #000000;
  font-weight: 400;
  font-size: 14px;
  font-family: "lato", sans-serif;
}

.access-color {
  background: #e1eef7;
  color: #ffffff;
}

.access-color .custom-control-input:checked ~ .custom-control-label::before {
  border-color: #ffffff;
  background-color: #4b80af;
}
.access-color-full {
  background: #a0c5e8;
  font-size: 14px;
  font-weight: 400;
  font-family: "lato", sans-serif;
  box-shadow: 0px 0px 8px 0px #0000002b;
}

.access-color-full .custom-control-label {
  color: #000000 !important;
}

.access-submodulecards .custom-control-label {
  color: #3a3c40 !important;
  font-family: "Montserrat", sans-serif;
  font-size: 12px;
  font-weight: 600;
}

.access-color-fullmain {
  background: #4b80af;
}
.folder-container {
  margin-top: 15px;
  background: #ffffff;
  box-shadow: 0px 0px 14px rgb(196 196 196 / 50%);
  border-radius: 10px;
}
.recinput .form-control {
  padding: 0.375rem 1.3rem !important;
}
.switch-position {
  position: absolute;
  top: 18px;
  right: 207px;
}

.switch-position .custom-control-label::before {
  border: 1px solid #8c8c8c;
}

.switch-position .custom-control-label::before {
  width: 24px;
  height: 14px;
}

.switch-position .custom-control-label::after {
  top: 8px;
  left: -33px;
  width: 6px;
  height: 6px;
  background-color: #ffffff;
  border-radius: 0.5rem;
  transition: transform 0.15s ease-in-out, background-color 0.15s ease-in-out,
    border-color 0.15s ease-in-out, box-shadow 0.15s ease-in-out;
  border: 1px solid #8c8c8c;
}

.switch-position .custom-control-input:checked ~ .custom-control-label::after {
  background-color: #20639b !important;
  border-color: white;
}

.switch-position .custom-control-label {
  font-family: "lato", sans-serif;
  font-size: 14px;
  font-weight: 400;
  color: #3e3e3e;
}

.folder-title {
  font-family: "lato", sans-serif;
  font-size: 14px;
  font-weight: 400;
  color: #3e3e3e;
}
.recsearchicon-pos {
  position: absolute;
  top: 5px;
  left: 5px;
}

.rec-dd-group {
  width: 100%;
  min-height: auto;
  max-height: 25vh;
  overflow: auto;
}

.rec-dd-group .custom-control-label {
  color: #3a3c40;
  font-size: 13px;
  font-weight: 500;
  font-family: "lato", sans-serif;
}

.custom-switch
  .custom-control-input:disabled:checked
  ~ .custom-control-label::before {
  background-color: #85b0d4;
  border-color: #85b0d4;
}

.custom-switch .custom-control-input:checked ~ .custom-control-label::after {
  background-color: #85b0d4;
  border-color: white;
}

.roleaccess-background
  .custom-switch
  .custom-control-input:checked
  ~ .custom-control-label::after {
  background-color: #20639b;
  border-color: #f6f9fb;
}

.roleaccess-background
  .custom-control-input:checked
  ~ .custom-control-label::before {
  border-color: #20639b;
  background-color: #20639b;
}

.roleaccess-background
  .custom-control-input:focus:not(:checked)
  ~ .custom-control-label::before {
  border-color: #adaaaa;
}

.roleaccess-background-dis
  .custom-switch
  .custom-control-input:checked
  ~ .custom-control-label::after {
  background-color: #85b0d4;
  border-color: #f6f9fb;
}

.roleaccess-background-dis
  .custom-control-input:checked
  ~ .custom-control-label::before {
  border-color: #20639b;
  background-color: #20639b;
}

.roleaccess-background-dis
  .custom-control-input:focus:not(:checked)
  ~ .custom-control-label::before {
  border-color: #adaaaa;
}

.gridgreencolorDynamic-user {
  position: absolute;
  border-radius: 2px 1px 1px 2px;
  width: 3px;
  height: 90%;
  margin: auto;
  background: #20639b;
  top: 2px;
  left: 3px;
}
.gridgreencolorDynamic-role {
  position: absolute;
  border-radius: 2px 1px 1px 2px;
  width: 3px;
  height: 90%;
  margin: auto;
  background: #20639b;
  top: 2px;
  left: 3px;
}
.blur {
  filter: blur(2px);
}
.error {
  font-size: 12px;
  border: 1px solid red !important;
}
.topDiv > .modaldisableinputField {
  font-family: "Poppins", sans-serif;
  background: #fdfdfd;
  border: 0.7px solid #bbbbbb;
  padding: 5px 10px;
  border-radius: 3px !important;
  color: #bbbbbb;
}

.input-placeholder {
  font-family: "Montserrat", sans-serif;
  font-size: 14px;
  font-weight: 400;
  color: #667085;
}

.slider.round {
  border-radius: 34px;
}

.slider.round:before {
  border-radius: 50%;
}
input:checked + .slider:before {
  -webkit-transform: translateX(26px);
  -ms-transform: translateX(26px);
  transform: translateX(13px);
  background: white;
}
input:checked + .slider {
  background-color: #72738e;
}

input:focus + .slider {
  box-shadow: 0 0 1px #2196f3;
}
.slider:before {
  position: absolute;
  content: "";
  height: 14px;
  width: 14px;
  left: 1px;
  bottom: 1px;
  background-color: #adb5bd;
  -webkit-transition: 0.4s;
  transition: 0.4s;
}
.switch input {
  opacity: 0;
  width: 0;
  height: 0;
}

.slider {
  position: absolute;
  cursor: pointer;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  border: 1px solid #72738e;
  -webkit-transition: 0.4s;
  transition: 0.4s;
}
.switch {
  position: relative;
  display: inline-block;
  width: 30px;
  height: 18px;
}
.add-access-user-card {
  color: red;
}
.access-cntrl-tabs .nav-tabs .nav-link.active,
.nav-tabs .nav-item.show .nav-link {
  font-weight: 700;
  font-size: 16px;
  color: #20639b !important;
  font-family: "lato", sans-serif;
}
.access-cntrl-tabs a {
  color: #000000 !important;
  font-weight: bold;
  font-size: 16px;
  font-family: "lato", sans-serif;
  line-height: 21px;
}
.access-cntrl-tabs li {
  width: 85px;
  text-align: center;
}
.access-cntrl-tabs .nav-tabs .nav-link {
  border: unset;
}

.access-cntrl-tabs .nav-tabs {
  border-bottom: 1px solid #d9d9d9;
  padding-left: 20px;
}
.access-cntrl-tabs .nav-link {
  display: block;
  padding: 17px 15px;
}
.access-cntrl-tabs .nav-tabs .nav-link.active {
  position: relative;
  /* border-bottom: 4px solid #20639B;
  box-shadow: 0px 4px 8px 0px #0000002B; */
}
.acs-sel-tab {
  position: absolute;
  background: #20639b;
  box-shadow: 0px 4px 8px 0px #0000002b;
  width: 85px;
  height: 4px;
  border-radius: 25px 25px 6px 6px;
  top: -8px;
  left: 20px;
}
.left-150 {
  left: 106px;
}
.left-20 {
  left: 20px;
}
.break {
  word-break: break-all;
}
.accesscontrol-role-main-container {
  position: absolute;
  width: 55%;
  height: calc(100vh - 100px);
  right: 2px;
  top: 14px;
  z-index: 5;
  background: #ffffff;
  box-shadow: 0px 4px 20px rgba(196, 196, 196, 0.5);
  border-radius: 8px;
}

.slide-leave-active,
.slide-enter-active {
  transition: 0.5s;
}

.slide-enter {
  transform: translate(100%, 0);
}

.slide-leave-to {
  transform: translate(100%, 0);
}
.accesscontrol-backArrow {
  top: 2px;
  left: -29px;
}
.addrole-heading {
  font-weight: 600;
  font-size: 16px;
  font-family: "Montserrat", sans-serif;
  color: #344054;
}

.prvilagetxt {
  font-weight: 500;
  font-size: 16px;
  font-family: "lato", sans-serif;
  color: #000000;
}
.prvilagetxt-2 {
  font-weight: 600;
  font-size: 14px;
  font-family: "lato", sans-serif;
  color: #72738e;
}
.previlagesubtxt {
  font-weight: 400;
  font-size: 14px;
  font-family: "lato", sans-serif;
  color: #72738e;
}
.newuserdesign .custom-switch {
  padding-top: 1rem;
}

.accesscontrol-modulecards {
  box-shadow: 0px 4px 15px rgba(196, 196, 196, 0.5);
  border-top: 1px solid #e2e2e2;
  background: #ffffff;
  border-radius: 5px;
  padding: 15px;
}

.accesscontrol-modulecards .custom-control-label {
  color: #3a3c40 !important;
  font-family: "Montserrat", sans-serif !important;
  font-size: 12px !important;
  font-weight: 600 !important;
}
.access-submodulecards {
  box-shadow: 0px 4px 15px rgba(196, 196, 196, 0.5);
  border-radius: 5px;
  padding: 12px 15px;
  border-top: 1px solid #e2e2e2;
}
.topDiv > .access-disableinput {
  background: #8c8c8c26 !important;
  /* opacity: 0.2; */
  color: #667085;
  border: 1px solid #d0d5dd;
  box-shadow: inset 0px 0px 4px rgba(0, 0, 0, 0.25);
  border-radius: 8px;
}
.access-control-filterbox {
  background: #20639b;
  border: 1px solid #20639b;
  border-radius: 25px;
  font-weight: 500;
  font-size: 13px;
  color: #ffffff;
  height: 35px;
  display: flex;
  justify-content: center;
  align-items: center;
  width: 130px;
  text-align: center;
}
.cj-filter-modal {
  background: #ffffff;
  border: 0.7px solid rgba(114, 115, 142, 0.5);
  box-sizing: border-box;
  box-shadow: 0px 4px 14px rgb(0 0 0 / 12%);
  border-radius: 5px;
  z-index: 6;
  position: absolute;
  width: 150px;
  /* height: 137px; */
  right: 37px;
  top: 93px;
}

.pd-checkboxes-background .custom-control-label {
  color: #3a3c40 !important;
  font-size: 13px;
  font-weight: 400;
  font-family: "lato", sans-serif;
  line-height: 21px;
}
.access-validationicon {
  position: absolute;
  top: 28px;
  right: 12px;
}

.custom-select {
  background: none;
}
.access-viewuser .custom-control-label {
  cursor: default;
}
.topDiv > .disable-inputField {
  font-family: "montserrat", sans-serif;
  font-size: 14px;
  font-weight: 500;
  background: #8c8c8c26 !important;
  color: #333333;
  border: 1px solid #d0d5dd;
  box-shadow: inset 0px 0px 4px rgba(0, 0, 0, 0.25);
  border-radius: 8px;
  height: 36px;
  padding-left: 9px;
  box-shadow: 0px 1px 2px 0px #1018280d;
}
.topDiv > .disable-acs-input-head {
  color: var(--bg-tertiary);
  background: #f4f4f4;
  position: absolute;
  left: 0.5vw;
  top: -9px;
  font-size: var(--size-10);
  line-height: 18px;
  z-index: 4;
  padding-left: 6px;
  padding-right: 4px;
}
.disable-div {
  height: calc(1.5em + 0.75rem + 2px);
  padding: 0.375rem 0.75rem;
  background-color: #e9ecef;
}

.access-role-background {
  background: #f6f9fb;
  border-radius: 10px;
  padding: 15px;
}

.access-role-background-overflow {
  height: calc(100vh - 507px);
  overflow-y: auto;
  overflow-x: hidden;
}

.view-role-background {
  background: #f6f9fb;
  border-radius: 10px;
  padding: 15px;
}

.view-role-background-overflow {
  height: calc(100vh - 375px);
  overflow-y: auto;
  overflow-x: hidden;
}

/* new table design starts from here */
.accessControl-main-class {
  height: calc(100vh - 170px);
  overflow: auto;
  margin-top: 15px;
  background: #ffffff;
  box-shadow: 0px 0px 14px rgb(196 196 196 / 50%);
  border-radius: 10px;
}

.userAccess-main-table {
  width: 100%;
  position: relative;
  height: calc(100vh - 242px);
  overflow-x: auto;
  overflow-y: hidden;
  padding: 20px;
}

.userAccess-table-head {
  min-width: 1060px;
  max-width: 100%;
  display: flex;
  align-items: center;
  padding: 10px 20px;
  font-style: normal;
  font-weight: 600;
  font-size: 14px;
  color: #20639b;
  font-family: "lato", sans-serif;
  background: #20639b1a;
}

.userAccess-table-body {
  min-width: 1060px;
  max-width: 100%;
  overflow-y: auto;
  height: calc(100vh - 345px);
}

.userAccess-table-body-2 {
  min-width: 1060px;
  max-width: 100%;
  overflow-y: auto;
  height: calc(100vh - 311px);
}

.userAccess-table-row {
  width: 100%;
  position: relative;
  border-radius: 3px;
  border: 0.5px solid #e5e5e5;
  background: #fcfcfc;
  box-shadow: 0px 4px 15px 0px #c4c4c480;
  display: flex;
  align-items: center;
  font-weight: 400;
  font-size: 15px;
  color: #20639b;
  font-family: "lato", sans-serif;
  padding: 15px 20px;
  margin: 10px 0px;
}

.userAccess-table-row:hover {
  background: #e7e8f5;
}

.bind-userAccess-col {
  width: 20%;
}

.userAccess-first-col {
  width: 15%;
}

.userAccess-second-col {
  width: 25%;
}

.userAccess-third-col {
  width: 15%;
}

.userAccess-fourth-col {
  width: 15%;
}

.userAccess-fifth-col {
  width: 15%;
}

.userAccess-sixth-col {
  width: 15%;
}

.roleAccess-first-col {
  width: 30%;
}

.roleAccess-second-col {
  width: 40%;
}

.roleAccess-third-col {
  width: 20%;
}

.roleAccess-fourth-col {
  width: 10%;
}

.topDiv > .inputField {
  font-weight: 400;
  font-size: 14px;
  line-height: 21px;
  background: #fdfdfd;
  border: 1px solid var(--input-border);
  box-shadow: 0px 0px 15px rgba(0, 0, 0, 0.1);
  border-radius: 3px !important;
  z-index: 1;
  padding-left: 6px;
  padding-right: 30px;
}

.access-switch .custom-control-input[disabled] ~ .custom-control-label,
.custom-control-input:disabled ~ .custom-control-label {
  color: #3a3c40;
  font-size: 12px;
  font-weight: 600;
  font-family: "montserrat", sans-serif;
}

.acs-box-border {
  border: 1px solid #8c8c8c54;
  border-radius: 6px;
  box-shadow: 0px 4px 8px 0px #0000002b;
}

.privilege-count-text {
  font-weight: 300;
  font-size: 12px;
}

.selectrole {
  display: flex;
  white-space: nowrap;
  overflow-x: auto;
  width: 94%;
  color: #495057;
}

.selectrole::-webkit-scrollbar {
  scroll-behavior: smooth;
  width: 0px !important;
  height: 0px !important;
  background-color: transparent !important;
}

.disableDeleteIcon {
  opacity: 0.6;
  cursor: initial;
}

.user-sub-font {
  font-family: "Montserrat", sans-serif;
  font-style: italic;
  font-weight: 400;
  font-size: 10px;
  line-height: 12px;
  color: #72738e;
}

.addUser-font {
  font-family: "Montserrat", sans-serif;
  font-weight: 500;
  font-size: 12px;
  line-height: 15px;
  color: #7a7a7a;
}
/* 
.pff-checkbox .custom-control-label::after {
  top: 2px !important;
} */

.custom-checkbox
  .custom-control-input:disabled:checked
  ~ .custom-control-label::after {
  top: 4px !important;
}

.acs-paginaTion-new {
  min-width: 1060px !important;
  max-width: 100% !important;
}

.new-font {
  font-family: "Montserrat", sans-serif;
  font-style: italic;
  font-weight: 500;
  font-size: 12px;
  line-height: 17px;
  color: #8c8c8c;
}

.role-first-section {
  height: 165px;
}
</style>
